// materialimport { useTheme } from '@material-ui/core/styles'
import { Box, Grid, Button, Card, Stack, Typography, TextField, MenuItem, Checkbox, makeStyles, CircularProgress, AvatarGroup, Tooltip, Avatar, InputAdornment, TableContainer, Table, Paper, TableHead, TableRow, TableCell, TableBody, IconButton, useMediaQuery, Slide, FormControlLabel, RadioGroup, FormControl, Radio, Autocomplete, Alert } from '@material-ui/core'
import { useTheme,alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { isAdminUser } from '../../../../utils/adminUserTypes';
import AddTask from '../../AddTask'
import { forwardRef, useEffect, useRef, useState } from 'react'
import { UserMoreMenu } from 'src/components/_dashboard/user/list';
import ConfirmationPopup from 'src/components/confirmationPopup';
import WarningMaterialPopup from 'src/components/WarningMaterialPopup';
import axios from 'axios';
import { BASE_URL, REST_API_END_POINT, UNITS } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import { KeyboardBackspaceOutlined, Login, Logout, QrCodeScanner, Search, Visibility ,Edit,Check, Delete, DeleteOutline, Replay} from '@material-ui/icons';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,Slider as Sliderw } from '@mui/material';
import ViewProductFormulaModal from 'src/components/ViewProductFormulaModal';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import moment from 'moment';
import { resolveSubtaskWorkflowLaborRate } from 'src/utils/laborTimelogCalc';
import FinishedProductmenu from 'src/components/_dashboard/blog/FinishedProductmenu';
import { empty } from 'src/Helpers/Common';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import QrReader from 'react-qr-reader';
import { Html5QrcodeScanner } from 'html5-qrcode';
import ReactToPrint, { useReactToPrint } from 'react-to-print'
import QRCode from 'react-qr-code';

const option = [
  // { id: 6, color:'error', value: 'In Active' },
  { id: 1, color:'primary', value: 'New' },
  { id: 2, color:'info', value: 'In Progress' },
  { id: 3, color:'success', value: 'Completed' },
  // { id: 4, color:'warning', value: 'Hold' },
  // { id: 5, color:'primary', value: 'Active' },
 
  // { id: 6, color:'success', value: 'Approved by Dev team' },
  // { id: 7, color:'success', value: 'Approved by the client' },
  // { id: 8, color:'primary', value: 'Reopen' },
]
const colors = [
  '#c9302c',
  '#5bc0de',
  '#0275d8',
  '#008000',
  '#f0ad4e',
  '#5cb85c',
  '#c9302c',
  '#5cb85c',
  '#5cb85c',
  '#5bc0de',
]
const alphanumericCompare = (a, b) => {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
};

const useStyles = makeStyles((theme) => ({
  card: {
      borderRadius: theme.spacing(1),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative', 
  },
  delete:{
    m:2,
    display:'flex',
    justifyContent:'flex-end' 
  },
  media: {
      height: 0,
      paddingTop: '100%', 
      width: '100%',
      objectFit: 'fill', 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      left: theme.spacing(1),
      zIndex:999,
  },
  gridContainer: {
      height: '350px', 
      overflowY: 'auto', 
      '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.1)',
          borderRadius: '4px',
        },
  },
}));

function ProjectStatusPopup({ open, onClose, staffTimeLogData, handleClockInOut, autoClockoutTime }) {
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [timerId]);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        handleClockInOut();
      }, autoClockoutTime * 60 * 1000);

      setTimerId(timer);
    } else {
      if (timerId) {
        clearTimeout(timerId);
      }
    }
  }, [open]);
 
  return (
      <Dialog  onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(false);
        }
      }}>
          <DialogTitle>Are you still working on this project?</DialogTitle>
          <DialogContent>
              <DialogContentText sx={{mt:3}}>
                  Do you want to continue working on "{staffTimeLogData?.task_name}" in "{staffTimeLogData?.project_name}"?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button variant='contained' onClick={() => { clearTimeout(timerId); onClose(true); }}>
                  Yes
              </Button>
              <Button variant='outlined' onClick={() => { clearTimeout(timerId); onClose(false); }}>
                  No
              </Button>
          </DialogActions>
      </Dialog>
  );
}
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const getInstallationStatusLabel = (status) => {
  const labels = { 1: 'Installs', 2: 'Pickup', 3: 'Shipping' };
  return labels[status] || '';
};
const getMixedInstallationMessage = (mixedStatus) => {
  if (!Array.isArray(mixedStatus) || mixedStatus.length === 0) return 'Installation';
  const labels = [...new Set(mixedStatus)]
    .sort((a, b) => a - b)
    .map(getInstallationStatusLabel)
    .filter(Boolean);
  if (labels.length === 0) return 'Installation';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
};

const rowStyle1 = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop:"5px"
};

const qrCodeSection = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // gap: '1mm',
};

const typographyStyle1 = {
  textAlign: 'center',
  color: 'black',
  fontSize: '6px',
  maxWidth: '100%', // Prevents overflow
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center', 
  padding:"2px"
  // height: '100%' // Ensure it takes full height for proper centering
};

export default function SubTasks({ details, taskData, data,setFetchData, projectMembers, taskId, projectId, setRefresh, refresh,currentTab,onDataChange,isMirrored }) {
  console.log('taskDataaaa', taskData)
  console.log('details++', details)
  console.log('projectIdprojectId', projectId)
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { enqueueSnackbar } = useSnackbar();
  const [singleData, setSingleData] = useState(null)
  const [add, setAdd] = useState(false)
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [isDelete,setIsDelete] = useState(false)
  const [isEdit,setIsEdit] = useState(false)
  const [deleteStates, setDeleteStates] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isSelectAll, setIsSelectAll] = useState(false)
  const [openService, setOpenService] = useState(false)
  const [confirmAdditionalJObCost, setConfirmAdditionalJObCost] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')
  const [materialData, setMaterialData] = useState(null)
  const [warningMaterialPopup, setWarningMaterialPopup] = useState(false)
  const [warningMaterialData, setWarningMaterialData] = useState(null)
  const [staffTimeLog, setStaffTimeLog] = useState(null)
  const [openPopup, setOpenPopup] = useState(false);
  const [fromStatus, setFromStatus] = useState(false);
  const [searchMaterial, setSearchMaterial] = useState('');
  const [qty, setQty] = useState(1);
  const [viewMaterialData, setViewMaterialData] = useState([]);
  const [viewMaterial, setViewMaterial] = useState(false);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  // Removed global stopwatch states
  // const [elapsedTime, setElapsedTime] = useState(0);
  // const [stopwatchData, setStopwatchData] = useState(null);
  // const [isStopwatchRunning, setIsStopwatchRunning] = useState(false);
  const [subtaskStopwatches, setSubtaskStopwatches] = useState({}); // New state for per-subtask stopwatch
  const [editingStopwatchId, setEditingStopwatchId] = useState(null);
  const [editedTime, setEditedTime] = useState("");

  const classes = useStyles();
  const [completeStatus, setCompleteStatus] = useState(1)
  const [checkedItems, setCheckedItems] = useState([]);
  const [popUpTime, setPopUpTime] = useState(0);
  const [autoClockoutTime, setAutoClockoutTime] = useState(0);
  const [openPopupComplete, setOpenPopupComplete] = useState(false)
  const user = JSON.parse(window.localStorage.getItem('user'))
  let userType = user.user_type
  const explodedPermissions = user?.exploded_permissions
  const hasJobPermission = explodedPermissions?.some((permission) => ['Update Job Status'].includes(permission)) ? true : false
 const hasEditSubtaskPermission = explodedPermissions?.some((permission) => ['Edit Subtask'].includes(permission)) ? true : false
const hasDeleteSubtaskPermission = explodedPermissions?.some((permission) => ['Delete Subtask'].includes(permission)) ? true : false
  const hasViewAsAdminPermission = explodedPermissions?.some((permission) =>
    ['View as admin', 'View Workflow as Admin'].includes(permission)
  )
 const canShowSubtaskMenu = (post) => {
  // Admin user can edit/delete menu based on permission
  if ( isAdminUser (Number(user?.user_type))) return true;

  // If user does not have View Sub Tasks as Admin permission,
  // normal flow: menu can show for their visible subtasks
  if (!hasViewAsAdminPermission) return true;

  if (hasEditSubtaskPermission || hasDeleteSubtaskPermission) return true;
  // If user has View Sub Tasks as Admin permission,
  // they can view all subtasks, but menu should show only
  // if they are part of that subtask
  const requestedUserId = Number(user?.user_id);

  return (
    Array.isArray(post?.teamMembers) &&
    post.teamMembers.some((member) => Number(member?.userId) === requestedUserId)
  );
};
  const changeWorkflowPermission = explodedPermissions?.some((permission) => ['Change Workflow'].includes(permission)) ? true : false
  const[skillsandServices,setSkillsService]=useState([])
  const [openQRScanner, setOpenQRScanner] = useState(false);
  const [finalTaskId, setFinalTaskId] = useState(null);
  const [finalTaskStatus, setFinalTaskStatus] = useState(null);
  const scannerRef = useRef(null);
  const [projectData,setProjectData] = useState(null) 
  console.log('projectData....', projectData)
  const [loading2,setLoading2] = useState(false)
  const [loadingInstall,setLoadingInstall] = useState(false)
  const [selectedService, setSelectedService] = useState(null);
  const [clockInServices,setclockInServices] = useState([])
  const [subTaskMembers,setSubTaskMembers] = useState([])
  /** labour_cost_services rate for active subtask (T&M: total_cost, else cost) */
  const [activeSubtaskWorkflowRate, setActiveSubtaskWorkflowRate] = useState(0)
  console.log('subTaskMemberssssss', subTaskMembers)
  const [clockInInputs, setClockInInputs] = useState([]);
  console.log('clockInInputs', clockInInputs)
  const [subTaskId, setSubTaskId] = useState(null);
  const [openViewProductFormulaModal, setOpenViewProductFormulaModal] = useState(false);
  const [addPartialStock, setAddPartialStock] = useState(false);
  const [partialModalOpen, setPartialModalOpen] = useState(false);
  const [openPartialConfirm, setOpenPartialConfirm] = useState(false);
  const [partialTargetProduct, setPartialTargetProduct] = useState(null);
  const [movingQty, setMovingQty] = useState(1);
  const [partialSize, setPartialSize] = useState('');
  const [convertionUnit, setConvertionUnit] = useState(null);
  const [convertionUnitName, setConvertionUnitName] = useState(null);
  const [unitType, setUnitType] = useState(null);
  const [convertionQty, setConvertionQty] = useState(0);
  const [convertionUnitPrice, setConvertionUnitPrice] = useState(0);
  const [convertionTotalPrice, setConvertionTotalPrice] = useState(0);
  const [autoFill, setAutoFill] = useState(true);
  const [partialErrors, setPartialErrors] = useState({});
  const [partialCondition, setPartialCondition] = useState(false);
  const [futureInstallations, setFutureInstallations] = useState([]);
  const [existingJobCostData, setExistingJobCostData] = useState(null);
  const [selectedInstallation, setSelectedInstallation] = useState(null);
  const [retryFirstApiCall, setRetryFirstApiCall] = useState(false);
  const [smallLabelSettings, setSmallLabelSettings] = useState({
    scale: 1,
    qrSize: 50,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    width: '0.9',
    height: '0.8',
    pageWidth: '8.27',
    pageHeight: '11.69',
    smallTitleFontSize: 6,
  });
  const [partialProductNew, setPartialProductNew] = useState(null);
  const detailsRef = useRef(null);
  //new change workflow sates
const [workflows, setWorkflows] = useState([]);
const isServiceTaskForWorkflow = taskData?.service_id != null && !taskData?.product_id;
const [workflowListKind, setWorkflowListKind] = useState(null); // 'product' | 'service'
const [openWorkflowDialog, setOpenWorkflowDialog] = useState(false);
const [openMembersPopup, setOpenMembersPopup] = useState(false);
const [popupMembers, setPopupMembers] = useState([]);
const [selectedWorkflow, setSelectedWorkflow] = useState(null);
const [workflowLoading, setWorkflowLoading] = useState(false);
const [workflowSaving, setWorkflowSaving] = useState(false);
const [openWorkflowConfirmDialog, setOpenWorkflowConfirmDialog] = useState(false);
const [allSubtasksCompleted, setAllSubtasksCompleted] = useState(false);



  // const filteredClockInServices = [
  //   ...clockInServices?.filter((item) => item.labour_cost_service_id !== 10),
  //   clockInServices?.find((item) => item.labour_cost_service_id === 10)
  // ].filter(Boolean);

const filteredClockInServices = clockInServices?.filter(item => {
  if (taskData?.service_id == null) {
    return !!item.recipe_id;
  }
  return true;
}) || [];



  console.log('taskDataaaaa filteredClockInServices', filteredClockInServices)
    console.log('taskDataaaaa', taskData)

  const isClockInDisabled = subTaskMembers.every((member) => {
  const entry = clockInInputs.find((e) => e.staff_id === member.staff_id);
  const hasHour = entry?.hour > 0;
  // const hasService = entry?.service_id && entry?.service_id !== '';
  return !(hasHour);
});

useEffect(() => {
  if (taskData?.service_id != null) {
    setSelectedService(taskData?.customer_order_product_id);
    console.log('taskData.service_id',taskData.customer_order_product_id)
    console.log('taskData.service_id data',taskData)
  }
}, [taskData]);

  useEffect(() => {
    if (openQRScanner) {
      setTimeout(() => {
        if (!scannerRef.current) {
          scannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          scannerRef.current.render(
            (decodedText) => {
              setSearchMaterial(decodedText);
              handleAddMaterialToJobCost(decodedText); // Automatically update material state
              setOpenQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500); // Ensure modal is fully rendered before initializing scanner
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [openQRScanner]);

  useEffect(()=>{
    fetchProjectData()
  },[])

  const fetchProjectData = async () => {
    try {
      const  res = await axios.post(`${REST_API_END_POINT}jobs/get-project-details-by-id`, { projectId: projectId });
      setProjectData(res?.data?.result[0]);
    } catch (error) {
      console.log("error",error)
      setProjectData(null)
    }
  }
  const userId = user?.user_id
  const[view,setView]=useState(false)
 console.log("##############details",details);
  const fetchClockSettings = async() => {
    try {
        const res = await axios.post(`${REST_API_END_POINT}settings/fetch-all-clock-settings`,{projectId, taskId})
        if(res.data.status === 1){
          setclockInServices(res?.data?.allServices)
            const settingsData = res.data.clocksettings
            settingsData?.map((item)=>{
              if(item?.id == 1){
                setPopUpTime(parseInt(item?.time))
              }else if(item?.id == 2){
                setAutoClockoutTime(parseInt(item?.time))
              }
            })
        }else{
          
            setPopUpTime(0)
            setAutoClockoutTime(0)
        }
    } catch (error) {
        console.log("Clock settings error : ",error)
        setPopUpTime(0)
        setAutoClockoutTime(0)
    }
  }
 
  useEffect(()=>{
    fetchClockSettings()
  },[])

  // Stopwatch Functions
  const fetchStopwatchData = async (subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/fetch`, {
        userId: user.user_id,
        subtaskId: subtaskId
      });

      setSubtaskStopwatches(prev => {
        const newStopwatches = { ...prev };
      
        if (res.data.status === 1 && res.data.result.length > 0) {
          const sortedEntries = res.data.result.sort((a, b) => {
            const timeA = a.end_time || a.start_time;
            const timeB = b.end_time || b.start_time;
            return timeB - timeA; // Sort in descending order
          });

          const stoppedEntries = sortedEntries.filter(e => e.status === 0);
          const runningEntry = sortedEntries.find(e => e.status === 1);
      
          // ✅ Sum all stopped durations
          const stoppedTime = stoppedEntries.reduce((sum, e) => {
            if (e.start_time && e.end_time) {
              return sum + (e.end_time - e.start_time);
            }
            return sum;
          }, 0);
      
          let totalElapsed = stoppedTime;
          let isRunning = false;
          let stopwatchData = null;
      
          if (runningEntry) {
            // Clamp to 0: client clock can lag server start_time by ~1s and go negative
            const runningSeconds = moment().unix() - Number(runningEntry.start_time);
            totalElapsed += Math.max(0, runningSeconds);
            isRunning = true;
            stopwatchData = runningEntry;
          } else {
            stopwatchData = stoppedEntries[0] || null;
          }
      
          newStopwatches[subtaskId] = {
            stopwatchData,
            isRunning,
            elapsedTime: Math.max(0, totalElapsed)
          };
        } else {
          newStopwatches[subtaskId] = {
            stopwatchData: null,
            isRunning: false,
            elapsedTime: 0
          };
        }
      
        return newStopwatches;
      });

    } catch (error) {
      console.error(`Error fetching stopwatch data for subtask ${subtaskId}:`, error);
      setSubtaskStopwatches(prev => ({
        ...prev,
        [subtaskId]: { stopwatchData: null, isRunning: false, elapsedTime: 0 }
      }));
    }
  };

  const startStopwatch = async (subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/start`, {
        userId: user.user_id,
        subtaskId: subtaskId,
        jobId: projectId
      });
      if (res.data.status === 1) {
        const now = moment().unix();
        const startedId =
          typeof res.data.result === 'object' && res.data.result !== null
            ? res.data.result.id ?? res.data.result
            : res.data.result;
        // Optimistic UI: start from 0 immediately (avoids brief negative from clock skew on refetch)
        setSubtaskStopwatches((prev) => ({
          ...prev,
          [subtaskId]: {
            stopwatchData: {
              ...(prev[subtaskId]?.stopwatchData || {}),
              id: startedId,
              start_time: now,
              end_time: null,
              status: 1,
              subtask_id: subtaskId,
            },
            isRunning: true,
            elapsedTime: Math.max(0, prev[subtaskId]?.elapsedTime || 0),
          },
        }));
        enqueueSnackbar("Stopwatch started", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Re-fetch to update state
      } else {
        enqueueSnackbar("Failed to start stopwatch", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error starting stopwatch:", error);
      enqueueSnackbar("Error starting stopwatch", { variant: 'error' });
    }
  };

  const stopStopwatch = async (stopwatchId, subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/stop`, {
        stopwatchId: stopwatchId,
        userId: user.user_id
      });
      if (res.data.status === 1) {
        enqueueSnackbar("Stopwatch stopped", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Re-fetch to update state
      } else {
        enqueueSnackbar("Failed to stop stopwatch", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error stopping stopwatch:", error);
      enqueueSnackbar("Error stopping stopwatch", { variant: 'error' });
    }
  };

  const clearStopwatch = async (subtaskId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}stopwatch/clear`, {
        subtaskId: subtaskId,
        userId: user.user_id
      });
  
      if (res.data.status === 1) {
        enqueueSnackbar("Stopwatch cleared", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Refresh UI
      } else {
        enqueueSnackbar("Failed to clear stopwatch", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error clearing stopwatch:", error);
      enqueueSnackbar("Error clearing stopwatch", { variant: 'error' });
    }
  };


  const resolveMemberLaborRate = (memberHourlyRate) => {
    const memberRate = Number(memberHourlyRate) || 0
    return activeSubtaskWorkflowRate > 0 ? activeSubtaskWorkflowRate : memberRate
  }

  const   handleClockinTime = (members,taskId,fromStatus=false)=>{
    try {
      const subtaskRow = data?.find((p) => Number(p.ID) === Number(taskId))
      const isTM = projectData?.project_category === 12
      const workflowRate = resolveSubtaskWorkflowLaborRate(subtaskRow, isTM)
      setActiveSubtaskWorkflowRate(workflowRate)
      setSubTaskMembers(members)
      setOpenService(true)
      setSubTaskId(taskId)
      setFromStatus(fromStatus)
    } catch (error) {
      console.log('error',error )
    }
  }

  const handleConfirmAdditionalJobCost = async () => {
  try{
    if(retryFirstApiCall){
      handleAddMaterialToJobCost(materialData.barcode,2)
      setRetryFirstApiCall(false)
      setConfirmAdditionalJObCost(false)
      setConfirmMessage('')
      setSearchMaterial('')
      setMaterialData(null)
      return;
    }
    let realQty = materialData?.balanceQty || (qty || 1)
    let values = [
      {
        productId: materialData.product_id || materialData.id,
        projectId: projectId,
        actual_quantity: materialData.actual_quantity || 0,
        actual_unit_cost: materialData.actual_unit_cost || 0,
        actual_total: materialData.actual_total || 0,

        // actual_quantity: project.unit_qty || 0,
        // actual_unit_cost: project.unit_cost || 0,
        // actual_total: project.actual_total_cost || 0,


        quantity: materialData?.balanceQty || (qty || 1),
        total: (materialData.unit_price * realQty) || (materialData.unit_cost * realQty),
        unitPrice: materialData.unit_price || materialData.unit_cost,
        for_product: selectedInstallation?.IsProductInstallation ? selectedInstallation?.location_id : null,
        for_service: selectedInstallation?.IsServiceInstallation ? selectedInstallation?.location_id : null,
      }
    ];  
    console.log('valuesssssssssssssssssssssss',values)
    axios.post(`${REST_API_END_POINT}project/add-job-cost`, 
      { userId: user.user_id, values, projectId, recipe: 0, selectedServices:[], scanQr : true, taskId,qty }, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else if (response?.data?.message) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      } else {
        enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
      }
      setConfirmAdditionalJObCost(false);
      setConfirmMessage('');
      setSearchMaterial('');
      setRefresh(!refresh);
      onDataChange()
    }).catch((error) => {
      console.error(error);
      enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
    })
    // setQty(1)
    }catch(error){
      console.log(error)
    }
  }

  const submitJobCostAPI = async (materialDataToUse) => {
    try {
      let realQty = materialDataToUse?.balanceQty || (qty || 1)
      // qtyForPrice
      let qtyAddToJob= (materialDataToUse?.ogRemainingQty - materialDataToUse?.movigPartialQty) || 0
      let values = [
        {
          productId: materialDataToUse.product_id || materialDataToUse.id,
          projectId: projectId,
          actual_quantity: materialDataToUse.actual_quantity || 0,
          actual_unit_cost: materialDataToUse.actual_unit_cost || 0,
          actual_total: materialDataToUse.actual_total || 0,
          quantity: materialDataToUse?.balanceQty || (qty || 1),
          total: (materialDataToUse.unit_price * qtyAddToJob) || (materialDataToUse.unit_cost * realQty),
          unitPrice: materialDataToUse.unit_price || materialDataToUse.unit_cost,
          movigPartialQty: materialDataToUse?.movigPartialQty || 0,
          ogRemainingQty: materialDataToUse?.ogRemainingQty || 0,
          qtyAddToJob:qtyAddToJob
        }
      ];  
      
      const response = await axios.post(`${REST_API_END_POINT}project/add-job-cost`, {
        userId: user.user_id,
        values,
        projectId,
        recipe: 0,
        selectedServices: [],
        scanQr: true,
        taskId,
      });
      
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        setRefresh(!refresh);
        onDataChange()
      } else if (response.data.message) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      } else {
        enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
      }
    } catch (error) {
      console.log('Error in submitJobCostAPI', error);
    }
  }

  const proceedWithMaterialAdditionFromData = async (materialDataToUse) => {
    try {
      if (addPartialStock) {
        
        let maxremQty = 0;
        let maxQty = 1;
        let qtyForPrice = 1;
        let unit_price = 1;
        if(materialDataToUse?.partial==1){
          // maxremQty = Number(materialDataToUse?.qty ?? materialDataToUse?.quantity ?? 0);
          // maxQty = Number(materialDataToUse?.qty ?? materialDataToUse?.quantity ?? 0)- qty;;
          maxremQty = Number(materialDataToUse?.qty ?? materialDataToUse?.quantity ?? 0)- qty;
          // maxremQty = Number(qty);

          // maxQty = Number(qty) - 1;
          maxQty = maxremQty;
          // maxQty = maxremQty - qty;
          qtyForPrice = maxremQty;

          unit_price = materialDataToUse?.unit_cost;
        }else{
          // maxremQty = Number(materialDataToUse?.unit_qty ?? materialDataToUse?.quantity ?? 0)
          maxremQty = qty * materialDataToUse?.convertion_qty;
          maxQty = qty * materialDataToUse?.convertion_qty -1;
          qtyForPrice = materialDataToUse?.convertion_qty;
          unit_price = Number(materialDataToUse?.unit_cost )/ Number(materialDataToUse?.convertion_qty);
        }
        
        const initialMovingQty = maxQty > 0 ? maxQty : 1
        console.log('initialMovingQty',initialMovingQty)
        console.log('initialMovingQty',maxQty)
        console.log('initialMovingQty',maxremQty)
        console.log('initialMovingQty',qty)
        console.log('initialMovingQtymaterialDataToUse',materialDataToUse)
        console.log('initialMovingQty',unit_price)
        console.log('initialMovingQty',Number(materialDataToUse?.unit_cost ))
        console.log('initialMovingQty',Number(materialDataToUse?.convertion_qty))
        console.log('initialMovingQty',materialDataToUse?.unit_cost)
        console.log('initialMovingQty',materialDataToUse?.convertion_qty)
        setMovingQty(initialMovingQty) 
        setPartialTargetProduct({...materialDataToUse,remainingQty:maxQty,qtyForPrice:qtyForPrice,ogRemainingQty:maxremQty,unit_price:unit_price})
        let unitType = UNITS.find(unit => unit.id === materialDataToUse?.unit_id)
        let partialUnitType = materialDataToUse?.partial_unit ? UNITS.find(unit => unit.id === (materialDataToUse?.partial_unit ?? materialDataToUse?.convertion_unit)) : (materialDataToUse?.convertion_unit ? (UNITS.find(unit => unit.id === (materialDataToUse?.convertion_unit))) : null)
        setUnitType(materialDataToUse?.partial_unit ?? materialDataToUse?.convertion_unit ?? null)
        setConvertionUnit(partialUnitType ?? unitType)
        setConvertionUnitName(partialUnitType?.name ?? unitType?.name)
        setConvertionQty(initialMovingQty)
        const baseUnitCost = Number(
          materialDataToUse?.unit_cost ??
            materialDataToUse?.material_unit_cost ??
            materialDataToUse?.unit_price ??
            materialDataToUse?.unitPrice ??
            0
        );

        const unitCost = initialMovingQty > 0 ? materialDataToUse?.partial==1 ? baseUnitCost : (baseUnitCost / qtyForPrice) : 0
        setConvertionUnitPrice(unitCost)
        setConvertionTotalPrice(unitCost * initialMovingQty);
        setAutoFill(true)
        setPartialErrors({})
        setPartialModalOpen(true)
        setAddPartialStock(false)
      } else {
        await submitJobCostAPI(materialDataToUse);
        setQty(1)
      }
    } catch (error) {
      console.log('Error in proceedWithMaterialAdditionFromData', error);
    }
  }

  const handleWarningConfirm = async () => {
    try {
      await proceedWithMaterialAdditionFromData(warningMaterialData)
      setWarningMaterialPopup(false)
      setWarningMaterialData(null)
      setSearchMaterial('')
    } catch (error) {
      console.log(error)
    }
  }

  const handleWarningClose = () => {
    setWarningMaterialPopup(false)
    setWarningMaterialData(null)
    setSearchMaterial('')
    setQty(1)
  }

  const handleClosePartialModal = () => {
    setQty(1)
    setPartialModalOpen(false);
    setMovingQty(1);
    setConvertionUnit(null);
    setPartialSize('');
    setConvertionUnitName(null);
    setConvertionQty(0);
    setConvertionUnitPrice(0);
    setConvertionTotalPrice(0);
    setAutoFill(true);
    setPartialErrors({});
  }

  const handleSubmitPartialFromWarning = () => {
    const newErrors = {};
    
    if (!movingQty || movingQty <= 0) newErrors.movingQty = "Required";
    if (!convertionUnit) newErrors.convertionUnit = "Required";
    if (!convertionQty || convertionQty <= 0) newErrors.convertionQty = "Required";
  
    if (Object.keys(newErrors).length > 0) {
      setPartialErrors(newErrors);
      return;
    }
    setOpenPartialConfirm(true);
    setPartialErrors({});
  };

  const handleMoveToPartialFromWarning = async () => {
    try {
      setOpenPartialConfirm(false);
      setPartialModalOpen(false);
      let response = await axios.post(`${REST_API_END_POINT}product/move-finished-product-partial`, 
        {userId: user.user_id, editFinishedProductId: partialTargetProduct?.id || partialTargetProduct?.product_id, movingQty, convertionUnit, convertionQty, convertionUnitPrice, convertionTotalPrice, autoFill,partialSize,fromScan:true })
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        setPartialProductNew(response.data?.newPartialItem);
        handleSmallPrint();
        
        await submitJobCostAPI({...partialTargetProduct,movigPartialQty:movingQty,});
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      handleClosePartialModal();
      setQty(1)
      setPartialTargetProduct(null);
    } catch (error) {
      console.error("Error : ", error);
      enqueueSnackbar('Error moving product to partial', { variant: 'error' });
    }
  }

  console.log('datadatadata====',data)
  const handleDeleteClick = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: true,
    }));
  };

  const handleCancelDelete = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: false,
    }));
  };
  const valuetext = (value) => {
   
    return `${value}%`
  }
  const updateStatus=(event,value)=>{
    
    let values={}
    let user=JSON.parse(window.localStorage.getItem('user'))
    values.completion=event.target.value
     values.projectId=projectId
    values.added_by=user.user_id
    values.taskId=value
    values.task=taskId
    
    if(event.target.value && values.taskId){
      axios.post(`${REST_API_END_POINT}project/update-project-sub-task-progress`,{ ...values },{
        headers: {
          'Content-Type': 'application/json',
        },
        // headers: { 'Content-Type': 'multipart/form-data' }
      })
    }
    
  }
  const handleDeleteSubTask = async (id) => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}project/delete-project-sub-task`,
        { id: Number(id), taskId, projectId, status: 0, userId, isTimeAndMaterial: projectData?.isTimeAndMaterial||projectData?.project_category === 12 }
      );

      if (response.data.status === 4) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        setRefresh(!refresh);
        setFetchData(true);

        // Same behavior as completing the last incomplete subtask:
        // backend already marks job complete — trigger convert-to-installation.
        const lastInstallationTask = await checkReadyForInstallationDelete();
        console.log(lastInstallationTask, " lastttttttt")
        const isLastSubtaskOfTask = checkIfLastSubtaskOfTask(id, 3);

        if(isLastSubtaskOfTask){
          handleFinalTaskUpdateStatus(null, id, 3);
        }
        if (lastInstallationTask) {
          if ((details?.project_category === 15 && details?.is_split_order !==1) || (projectData?.project_category === 15 && !projectData?.is_split_order)) {
            setFinalTaskStatus(3);
          } else {
            setFinalTaskStatus(9);
          }

          const hasDeliveryType = taskData?.service_delivery_type_id || taskData?.delivery_type_id || taskData?.task_delivery_type;
          if (hasDeliveryType) {
            setCompleteStatus(Number(taskData?.service_delivery_type_id || taskData?.delivery_type_id || taskData?.task_delivery_type || 1));
            await convertJObToInstallation(null, false, true);
          } else {
            if (details?.project_category == 14) {
              setCompleteStatus(1);
            }
            await convertJObToInstallation();
          }
        }

      } else if (response.data.status === 5) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }

      handleCancelDelete(id);
    } catch (error) {
      console.error("Error deleting subtask:", error);
    }
  };

  const handleFetchSubTask = (id)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/view-project-sub-task`,{ id: Number(id) },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          // enqueueSnackbar(response.data.message, { variant: 'success' });
          setSingleData(response.data.result[0])
          setIsEdit(true)
         
        }else if(response.data.status === 0){
          // enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        handleCancelDelete(id)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleFetchSubTaskView = (id,view=true)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/view-project-sub-task`,{ id: Number(id) },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){ 
          // enqueueSnackbar(response.data.message, { variant: 'success' });
        
          setSingleData(response.data.result[0])

          setIsEdit(true)
          setView(view)
        }else if(response.data.status === 0){
          // enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        handleCancelDelete(id)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }
  const handleUpdateStatus = async(id,status)=>{
    try {
      if(isLoggedIn){
        enqueueSnackbar('Please clockout', { variant: 'error' });
      }else{
        const  user  = JSON.parse(window.localStorage.getItem('user'))
        
        // Special split: category 15 parent-facility split, OR non-split product card with product id
        const isSpecialSplitOrderCondition = ((details?.project_category == 15 && details?.for_parent_facility == 1 && details?.is_split_order == 1) || (details?.is_split_order !== 1 && taskData?.customer_order_product_id != null));
        const hasProductId = taskData?.customer_order_product_id != null || taskData?.is_manually_added == 1;
        const isLastSubtaskOfTask = checkIfLastSubtaskOfTask(id, status);    
        // Normal flow: check if all tasks are ready for installation
        const lastInstallationTask = await checkReadyForInstallation()
        console.log(lastInstallationTask ," lastttttttt")
         // If special condition is met, DO NOT show confirmation popup.
         // Directly complete this subtask and convert using taskData.delivery_type_id.
         // Manual tasks must not auto-convert the whole job while other tasks (e.g. additional services) are pending.
         if (isSpecialSplitOrderCondition && hasProductId && isLastSubtaskOfTask && status == 3 && taskData?.is_manually_added != 1) {
          // No popup for special split order: use task's delivery_type_id and reuse final handler
          const autoCompleteStatus = Number(taskData?.service_delivery_type_id || taskData?.delivery_type_id || taskData?.task_delivery_type || 1)
          setCompleteStatus(autoCompleteStatus)
          handleFinalTaskUpdateStatus(null, id, status)
          return; // Don't proceed with normal flow
      
}else if(status == 3 && lastInstallationTask && (taskData?.service_delivery_type_id || taskData?.delivery_type_id || taskData?.task_delivery_type)){
          setCompleteStatus(Number(taskData?.service_delivery_type_id || taskData?.delivery_type_id || taskData?.task_delivery_type || 1))
          handleFinalTaskUpdateStatus(null, id, status)
          return;
        }
        else if (lastInstallationTask && status == 3) {
          // if(data?.noServiceNoTask == 1){
          if(false){
            setCompleteStatus(1)
            setFinalTaskId(taskId)
            setFinalTaskStatus(status)
            handleFinalTaskUpdateStatus()
          }else{
            // setOpenPopupComplete(true)
            setFinalTaskId(id)
            setFinalTaskStatus(status)
          }
        }else {
          // Stopwatch logic for status update
          if (status === 2 && !subtaskStopwatches[id]?.isRunning) { // 'In Progress'
            startStopwatch(id);
          } else if (status === 3 || status === 6) { // 'Completed' or 'In Active'
            const currentStopwatch = subtaskStopwatches[id];
            if (currentStopwatch && currentStopwatch.isRunning) {
              stopStopwatch(currentStopwatch.stopwatchData.id, id);
            }
          }

        axios.post(`${REST_API_END_POINT}project/update-project-sub-task-status`,{ taskId: Number(id),task:Number(taskId),projectId,status,userId:user.user_id },{
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if(response.data.status === 1){
            onDataChange()
            setRefresh(!refresh);
            if(response.data.readyForInstallation){
              // convertJObToInstallation()
              console.log("dfgidfbgdfgb");
              if(details?.project_category == 14){
                setCompleteStatus(1);
                convertJObToInstallation(user.user_id)
              }
              // else{
              //   setOpenPopupComplete(true)
              // }
            }
            fetchStopwatchData(id); // Refresh stopwatch data after status change
            enqueueSnackbar(response.data.message, { variant: 'success' }); // Moved outside if (readyForInstallation)

            // setSingleData(response.data.result[0])
            setFetchData(true)
          }else if(response.data.status === 0){
            // enqueueSnackbar(response.data.message, { variant: 'error' });
          }
          // setIsDelete(false)
        }).catch((error) => {
          console.error(error);
        })
      }
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleFinalTaskUpdateStatus = async(stockData, overrideFinalTaskId = null, overrideFinalTaskStatus = null)=>{
    try {
      if(isLoggedIn){
        enqueueSnackbar('Please clockout', { variant: 'error' });
      }else{    
        setLoadingInstall(true)   
        const  user  = JSON.parse(window.localStorage.getItem('user'))
        
        // Special split: category 15 parent-facility split, OR non-split product card with product id
        const isSpecialSplitOrderCondition = ((details?.project_category == 15 && details?.for_parent_facility == 1 && details?.is_split_order == 1) || (details?.is_split_order !== 1 && taskData?.customer_order_product_id != null));
        const taskIdToUse = overrideFinalTaskId != null ? overrideFinalTaskId : finalTaskId
        const statusToUse = overrideFinalTaskStatus != null ? overrideFinalTaskStatus : finalTaskStatus

        axios.post(`${REST_API_END_POINT}project/update-project-sub-task-status`,{ taskId: Number(taskIdToUse),task:Number(taskId),projectId,status :statusToUse,userId:user.user_id,projectCategory: projectData?.project_category,request_id :projectData?.request_id,stockData: stockData || null},{
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if(response.data.status === 1){
            onDataChange()
            setRefresh(!refresh);
            
            // For special split order condition, DO convert to installation using the special endpoint
            // (convertJObToInstallation decides the endpoint internally)
            if(isSpecialSplitOrderCondition && taskData?.is_manually_added != 1){
              if (response.data.isGroupCompleted !== false) {
                convertJObToInstallation(stockData,isSpecialSplitOrderCondition)
              } else {
                enqueueSnackbar("Subtask completed. Conversion will occur after all tasks in the group are completed.", { variant: 'info' });
                setOpenPopupComplete(false)
              }
            }else if(statusToUse == 3 && response.data.readyForInstallation && (taskData?.service_delivery_type_id || taskData?.delivery_type_id || taskData?.task_delivery_type)){
              // Only convert when every task (including additional services) is complete
              const directInstall = true
              convertJObToInstallation(stockData,false,directInstall)
            }else{
            if(response.data.readyForInstallation){
              // convertJObToInstallation()
              console.log("dfgidfbgdfgb");
              if(details?.project_category == 14){
                setCompleteStatus(1);
                convertJObToInstallation(stockData)
              }
              else{
                convertJObToInstallation(stockData)
              }
            }else{
              enqueueSnackbar(response.data.message, { variant: 'success' });
              // if(projectData?.project_category == 12){
              // enqueueSnackbar("Job has been sent for review", { variant: 'success' });

              // }
              setOpenPopupComplete(false)
            }
          }
            // setSingleData(response.data.result[0])
            setFetchData(true)
            setLoadingInstall(false)
          }else if(response.data.status === 0){
            setLoadingInstall(false)
            // enqueueSnackbar(response.data.message, { variant: 'error' });
          }
          // setIsDelete(false)
        }).catch((error) => {
          console.error(error);
          setLoadingInstall(false)
        })
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  // const convertJObToInstallation = async(userId)=>{
  //   const res = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,
  //     { selectedIds: Number(projectId), userId: userId,completeStatus:Number(completeStatus),clientId:details?.customer_id})
  //     if(res.data.status===1) {
  //       setOpenPopupComplete(false);
  //       // enqueueSnackbar(`${data?.noServiceNoTask == 1 ? 'Moved To "No Service No Task"' : Number(completeStatus) === 1
  //       enqueueSnackbar(`${data?.noServiceNoTask == 1 ? 'Job completed without installation' : Number(completeStatus) === 1
  //         ? 'Moved To Installs'
  //         : Number(completeStatus) === 2
  //         ? 'Moved To Pickup'
  //         : 'Moved To Shipping'} Successfully`, { variant: 'success' });
  //         // onDataChange()
  //     }else{
  //       enqueueSnackbar("Not Moved To Installation", { variant: 'error' });
  //     }
  // }

  const convertJObToInstallation = async (stockData,isSpecialSplitOrderCondition=false,directInstall=false) => {
    setLoadingInstall(true)
    try {
      const apiCompleteStatus = (isSpecialSplitOrderCondition || directInstall)
        ? Number(taskData?.service_delivery_type_id || taskData?.delivery_type_id || taskData?.task_delivery_type || 1)
        : Number(completeStatus)

        const isProduct = taskData?.product_id ? true : false;
      // Handle "Add to stock" option for no charge projects (category = 13)
      if(Number(apiCompleteStatus) === 4 && projectData?.project_category === 13) {
        const res = await axios.post(`${REST_API_END_POINT}installation/complete-job-no-charge`,
          { 
            selectedIds: Number(projectId), 
            userId: user.user_id, 
            completeStatus: Number(apiCompleteStatus), 
            clientId: details?.customer_id,
            stockData: stockData || null
          })
        if(res.data.status === 1) {
          setOpenPopupComplete(false);
          enqueueSnackbar('Job completed and stock added successfully', { variant: 'success' });
          setFetchData(true)
        } else {
          enqueueSnackbar("Failed to complete job and add stock", { variant: 'error' });
        }
        setLoadingInstall(false)
        return;
      }

      // if(isSpecialSplitOrderCondition){
      //   console.log('isSpecialSplitOrderCondition 1111', isSpecialSplitOrderCondition)
      //   return;
      // }
      const isBuildOrderJob =
        (details?.project_category === 15 && details?.is_split_order !== 1) ||
        (projectData?.project_category === 15 && projectData?.is_split_order !== 1);

      const endpoint = isSpecialSplitOrderCondition
        ? 'installation/convert-job-to-installation-split-product'
        : isBuildOrderJob
        ? 'installation/complete-job-build-order'
        : 'installation/convert-job-to-installation';

      const response = await axios.post(`${REST_API_END_POINT}${endpoint}`, {
        selectedIds: Number(projectId),
        userId: user.user_id,
        completeStatus: Number(apiCompleteStatus),
        clientId: details?.customer_id,
        projectId: Number(projectId), // Needed for build-order endpoint
        userType: user?.user_type,     // Needed for build-order endpoint
        stockData: stockData || null,
        // for split-product conversion (backend requires this)
        customer_order_product_id: taskData?.customer_order_product_id || null,
        isProduct: isProduct,
        is_scheduled: taskData?.is_scheduled || false,
        from_job :1
      });

      const mixedInstallation = response.data?.mixed_installation
      const mixed_status = response.data?.mixed_status
      const mixedInstallMessage = getMixedInstallationMessage(mixed_status)

      if (response.data.status === 1) {
        setOpenPopupComplete(false);
        setLoadingInstall(false)
        fetchProjectData()
        // enqueueSnackbar(`${data?.noServiceNoTask == 1 ? 'Moved To "No Service No Task"' : Number(completeStatus) === 1
        enqueueSnackbar(`${data?.noServiceNoTask == 1 ? 'Job completed without installation' :
          mixedInstallation ? `Moved To ${mixedInstallMessage}` :
          Number(apiCompleteStatus) === 1
          ? 'Moved To Installs'
          : Number(apiCompleteStatus) === 2
          ? 'Moved To Pickup'
          : 'Moved To Shipping'} Successfully`, { variant: 'success' });
          // onDataChange()
      }else{
        setLoadingInstall(false)
        // enqueueSnackbar(
        //   response.data?.message || `Not Moved To ${mixedInstallMessage || 'Installation'}`,
        //   { variant: 'error' }
        // );
      }
    } catch (error) {
      console.error("Installation conversion error:", error);
      enqueueSnackbar("Something went wrong", { variant: 'error' });
      setLoadingInstall(false)
    }
  };

  const handleUpdateAllStatus = (status) => {
    try {
      if(isLoggedIn){
        enqueueSnackbar('Please clockout', { variant: 'error' });
      }else{
        const user = JSON.parse(window.localStorage.getItem('user'))
        let resultArray = []
        checkedItems?.map(async(id)=>{
          const response = await axios.post(`${REST_API_END_POINT}project/update-project-sub-task-status`,{ taskId: Number(id),task:Number(taskId),projectId,status,userId:user.user_id },{
            headers: {
              'Content-Type': 'application/json',
            },
          })
          if(response.data.status === 1){
            resultArray.push(response.data.status);
            onDataChange()
            if(response.data.readyForInstallation){
              console.log("dfgidfbgdfgb",details);
              if(details?.project_category == 14){
                setCompleteStatus(1);
                convertJObToInstallation(user.user_id)
              }else{
                // setOpenPopupComplete(true)
              }
              // convertJObToInstallation(projectId,user.user_id)
            }
          }
        })
        // console.log('resultArray=====',resultArray)
        // console.log('checkedItems=====',checkedItems)
        // if(resultArray?.length == checkedItems?.length){
        //   enqueueSnackbar("Status updated successfully for all subtasks", { variant: 'success' });
        // }else{
        //   enqueueSnackbar("Failed to update status for all subtasks", { variant: 'error' });
        // }
        enqueueSnackbar("Status updated successfully for all subtasks", { variant: 'success' });
        setFetchData(true);
      }
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleClose =()=>{
    setOpenService(false)
    setClockInInputs([])
    setSubTaskMembers([])
    setSubTaskId(null)
  }

  const handleCheckboxChange = (id) => {
    setCheckedItems((prevState) => {
      const isPresent = prevState.includes(id);
      const updatedState = isPresent
        ? prevState.filter((item) => item !== id)
        : [...prevState, id];
      return updatedState;
    });   
  };

  const handleSelectAll = () => {
    if(isSelectAll){
      setIsSelectAll(false);
      setCheckedItems([]);
    }else{
      const allIds = data?.map((post) => String(post.ID)) || [];
      setCheckedItems(allIds);
    }
    setIsSelectAll(!isSelectAll);
  }

  const fetchTimeLogData = async () => {
    try{
      const res = await axios.post(`${REST_API_END_POINT}project-task/fetch-clockedIn-staff-task-timelog`,
      {projectId:projectId,taskId:taskId,userId:userId})
      if(res.data.status===1){
        const staffTimeLogData = res.data.result[0]
        let taskIds = staffTimeLogData?.sub_task_id
        taskIds = taskIds?.toString();
        const taskArray = taskIds?.split(",");
        setCheckedItems(taskArray)
        setStaffTimeLog(staffTimeLogData)
        if(staffTimeLogData.end_time === null){
          setIsLoggedIn(true)
        }else{
          setIsLoggedIn(false)
        }
      }else{
        setStaffTimeLog(null)
        setIsLoggedIn(false)
        setCheckedItems([])
      }
    }catch(error){
      console.log('Error fetching : ',error);
    }
  }

  const checkReadyForInstallation = async()=>{
    try {
         const  res = await axios.post(`${REST_API_END_POINT}project/check-ready-for-installation`,{userId,projectId,userType:user.user_type,projectCategory: projectData?.project_category,request_id :projectData?.request_id})

        if(res?.data?.status===1){
         return res?.data?.readyForInstallation
        }
    }catch(error){
      console.log('Ready For Installation error : ',error);
    }
  }

  // Check if this is the last subtask of the current task
  const checkIfLastSubtaskOfTask = (subtaskId, status) => {
    if (status !== 3) return false; // Only check when completing
    
    // Count completed subtasks in the current task
    // const completedCount = data?.filter(item => item.status === 3).length || 0;
    const totalSubtasks = Number(taskData?.subtask_count ?? 0);
    const completedSubtasks = Number(taskData?.subtask_completed_count ?? 0);
    const currentSubtask = data?.find(item => item.ID === subtaskId);
    
    // If current subtask is not completed yet, add 1 to count
    const willBeCompleted = currentSubtask?.status !== 3;
    const totalCompletedAfter = willBeCompleted ? completedSubtasks + 1 : completedSubtasks;
    
    // Check if all subtasks of this task will be completed after this
    // return totalCompletedAfter === data?.length;
    return totalSubtasks > 0 && totalCompletedAfter === totalSubtasks;
  }

  const checkReadyForInstallationDelete = async()=>{
    try {
        const  res = await axios.post(`${REST_API_END_POINT}project/check-project-completed`,{projectId,userId})

        if(res?.data?.status===1){
          const allProjectCompleted = res?.data?.pendingTasks?.length == 0 ? true : false
          return allProjectCompleted
        }
    }catch(error){
      console.log('Ready For Installation error : ',error);
    }
  }

  // useEffect(() => {
  //   checkReadyForInstallation()
  // },[projectId])

  useEffect(()=>{
    fetchTimeLogData()
  },[isLoggedIn])

  const runningStopwatchKey = Object.entries(subtaskStopwatches)
    .filter(([, state]) => state.isRunning)
    .map(([subtaskId]) => subtaskId)
    .sort()
    .join(',');

  // Tick elapsed time only while stopwatches are running (avoid resetting interval on every second)
  useEffect(() => {
    if (!runningStopwatchKey) return;

    const runningIds = runningStopwatchKey.split(',').filter(Boolean);
    const interval = setInterval(() => {
      setSubtaskStopwatches((prev) => {
        const next = { ...prev };
        let changed = false;

        runningIds.forEach((subtaskId) => {
          const state = prev[subtaskId];
          if (state?.isRunning) {
            changed = true;
            next[subtaskId] = {
              ...state,
              elapsedTime: Math.max(0, (state.elapsedTime || 0) + 1),
            };
          }
        });

        return changed ? next : prev;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [runningStopwatchKey]);
  

  // Fetch all stopwatch data for subtasks when component mounts or 'data' changes
  useEffect(() => {
    if (data && data.length > 0 && user?.user_id) {
      data.forEach(subtask => {
        fetchStopwatchData(subtask.ID);
      });
    }
  }, [data, user?.user_id]);

  useEffect(() => {
    if(isLoggedIn){
      const intervalId = setInterval(() => {
          setOpenPopup(true);
      }, popUpTime * 60 * 1000);

      return () => {
          clearInterval(intervalId);
      };
    }
}, [isLoggedIn]);

const updateClockInInput = (staffId, data) => {
  setClockInInputs((prev) => {
    const exists = prev.find((item) => item.staff_id === staffId);
    if (exists) {
      return prev.map((item) =>
        item.staff_id === staffId ? { ...item, ...data } : item
      );
    } else {
      return [...prev, { staff_id: staffId, ...data }];
    }
  });
};

const getClockInPayload = () => {
  const now = moment().unix();
  // Get task and subtask names once
  const subtaskData = data?.find(item => item.ID === subTaskId);
  const subtaskName = subtaskData?.name || 'N/A';
  const taskName = taskData?.task_name || taskData?.name || 'N/A';
  
  return clockInInputs
    .filter((entry) => {
      const hasHour = entry.hour > 0;
      return hasHour;
    })
    .map((entry) => {
      // Find staff member to get name
      const staffMember = subTaskMembers.find(member => 
        member.staff_id === entry.staff_id || 
        member.id === entry.staff_id || 
        member.userId === entry.userId
      );
      const staffName = staffMember?.name || staffMember?.staff_name || 'N/A';
      
      const resolvedRate = entry.hourly_rate || 0;
      const calculatedTotalRate = Number((entry.hour * resolvedRate).toFixed(2));
      
      return {
        ...entry,
        subtask_id: subTaskId,
        start_time: now - Math.round(entry.hour * 3600),
        end_time: now,
        staff_name: staffName,
        task_name: taskName,
        subtask_name: subtaskName,
        total_hourly_rate: calculatedTotalRate,
        isIncremental: true
      };
    });
};



// const handleClockInOut = async()=>{
//   setLoading2(true)
//   try {
//     if(checkedItems?.length > 0){
//       let res = '';
//       const now = Math.round(moment().valueOf() / 1000);
//       if(isLoggedIn){
//         const timeLogId = staffTimeLog?.id
//         const startTime = staffTimeLog?.start_time
//         const staffId = staffTimeLog?.staff_id
//         const staffHourlyRate = staffTimeLog?.staff_hourly_rate || 20
//         res = await axios.post(`${REST_API_END_POINT}project-task/update-staff-task-timelog`,{checkedItems, projectId, userId, timeLogId,taskId,startTime, now, staffId, staffHourlyRate,selectedService})
//         setFetchData(true)
//       }else{
//         res = await axios.post(`${REST_API_END_POINT}project-task/add-staff-task-timelog`,{checkedItems, projectId, userId,taskId,now,selectedService})
//         // setFetchData(true)
//       }
//       setIsLoggedIn(!isLoggedIn)
//       setOpenPopup(false);
//       setElapsedTime(0)
//       if(res.data.status===1){
       
//         if(res.data.result === 'add'){
//           enqueueSnackbar('Clocked In successfully', { variant: 'success' });
//           setLoading2(false)
//           setOpenService(false)
//         }else if(res.data.result === 'update'){
//           enqueueSnackbar('Clocked Out successfully', { variant: 'success' });
//           setLoading2(false)
//           setOpenService(false)
//         }
//       }else{
//         console.log('handleClockInOut res : ',res.data);
//         setLoading2(false)
//       }
//     }else{
//       enqueueSnackbar("Please select atleast one sub task",{variant:'error'})
//       setLoading2(false)
//     }
//   }catch(error){
//     console.log('HandleClockInOut error : ',error);
//     setLoading2(false)
//     setOpenService(false)
//   }
// }

const handleClockInOut = async() => {
  setLoading2(true)
  const now = moment().unix();
  const memberClockins = getClockInPayload();

  if (memberClockins.length === 0) {
    enqueueSnackbar("Please enter time and select service for at least one member", { variant: 'error' });
    return;
  }

  const payload = {
    projectId,
    taskId,
    userId,
    isDriver: false,
    memberClockins,
    checkedItems: [String(subTaskId)],
    now,
    request_id: details?.request_id,
    manual_time :true
  };

  console.log('🧾 Final Payload (not submitted):', payload);
  try {
    const res = await axios.post(
      `${REST_API_END_POINT}project-task/update-staff-task-timelog`,
      payload
    );
    console.log('✅ API Response:', res.data);
    if (res.data.status === 1) {
      enqueueSnackbar('Time log added successfully ', { variant: 'success' });
      setClockInInputs([]);
      setActiveSubtaskWorkflowRate(0);
      setElapsedTime(0);    
      setIsLoggedIn(false);  
      setFetchData(true);
    } else {
      console.log('⚠️ failed to add Time log', res.data);
      enqueueSnackbar("Clock-in failed", { variant: 'error' });
    }
    setOpenService(false)
    if(fromStatus){
      handleUpdateStatus(subTaskId,3);
    }
    handleClose();
    setLoading2(false)
    setLoadingInstall(false)
  } catch (error) {
    console.error('❌ API Error:', error);
    enqueueSnackbar("Clock-in failed", { variant: 'error' });
    handleClose(); 
    setLoading2(false)
    setLoadingInstall(false)
  }
};


const handleClosePopup = (continueWorking) => {
  setOpenPopup(false);
  if (!continueWorking) {
    handleClockInOut();
  }
};

useEffect(() => {
  if(staffTimeLog){
    const interval = setInterval(() => {
      const now = Math.round(moment().valueOf() / 1000);
      const difference = now - staffTimeLog?.start_time;

      setElapsedTime(difference);
    }, 1000);

    return () => clearInterval(interval);
  }
}, [staffTimeLog]);

  const secondsToHHMMSS = (totalSeconds) => {
    const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
    const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${h}:${m}:${s}`;
  };

  const hhmmssToSeconds = (hhmmss) => {
    const parts = hhmmss.split(':').map(Number);
    if (parts.length === 3) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else if (parts.length === 2) { // Handle HH:MM format if needed
      return parts[0] * 3600 + parts[1] * 60;
    }
    return 0; // Default to 0 if format is incorrect
  };

  const handleEditStopwatch = (stopwatchId, elapsedTime) => {
    setEditingStopwatchId(stopwatchId);
    setEditedTime(secondsToHHMMSS(elapsedTime));
  };

  const handleSaveEditedTime = async (stopwatchId, subtaskId) => {
    try {
      const newElapsedTime = hhmmssToSeconds(editedTime);
      if (isNaN(newElapsedTime)) {
        enqueueSnackbar("Invalid time format. Please use HH:MM:SS", { variant: 'error' });
        return;
      }

      const res = await axios.post(`${REST_API_END_POINT}stopwatch/update`, {
        stopwatchId: stopwatchId,
        userId: user.user_id,
        updateData: { total_time: newElapsedTime }, // Assuming backend expects total_time in seconds
      });

      if (res.data.status === 1) {
        enqueueSnackbar("Stopwatch entry updated successfully", { variant: 'success' });
        fetchStopwatchData(subtaskId); // Refresh UI
      } else {
        enqueueSnackbar("Failed to update stopwatch entry", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error saving edited time:", error);
      enqueueSnackbar("Error saving edited time", { variant: 'error' });
    } finally {
      setEditingStopwatchId(null);
      setEditedTime("");
    }
  };

  const handleTypographyClick = () => {
   
    setIsEdit(true);
  };
  const fetchAllSkills = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}settings/get-all-settings`, {userId:user.user_id, userType: user.user_type})
      let data = response.data.results.services;
      setSkillsService(data)     
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(()=>{
    fetchAllSkills()
  },[isEdit])

  const getMostCommonStatus = () => {
    const statusCount = {};
    
    data?.forEach((post) => {
      const status = post?.status;
      if (status) {
        statusCount[status] = (statusCount[status] || 0) + 1;
      }
    });
  
    const mostCommonStatus = Object.keys(statusCount).reduce((a, b) => 
      statusCount[a] > statusCount[b] ? a : b
    );
    return mostCommonStatus;
  };

  const handleAddMaterialToJobCost = async (materialBarcode,initialTry = 1) => {
    try{
      if(materialBarcode && materialBarcode !=''){
        console.log('materialBarcodematerialBarcode',materialBarcode)
        if (materialBarcode.startsWith('C')) {
          if(details?.project_category == 12){
            return enqueueSnackbar("Can't add a catalog item to a T&M job.", { variant: 'error' });
            }
            const response = await axios.post(
          `${REST_API_END_POINT}project/update-product-in-jobcost`,
          { userId: user.user_id, materialBarcode, projectId, taskId ,qty},
        )
        // if (response.data.status === 1) {
        //   enqueueSnackbar(response.data.message, { variant: 'success' })
        //   setQty(1)
        //   setSearchMaterial('')
        // }else if (response.data.message) {
        //   enqueueSnackbar(response.data.message, { variant: 'error' })
        // } else {
        //   enqueueSnackbar('Error adding Jobcost', { variant: 'error' })
        // }
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' })
          setQty(1)
          setSearchMaterial('')
        } else if (response.data.status === 2 || response.data.status === 3 || response.data.status === 4 || response.data.status === 6) {
          setConfirmAdditionalJObCost(true)
          setConfirmMessage(response.data.message)
          setMaterialData(response.data.materialData)
        } else if (response.data.status === 5) {
          if(response.data.materialData?.qty < qty){
            enqueueSnackbar("Quantity is greater than the available quantity", { variant: 'error' })
          }else{
            // let remainingQty = response.data.materialData?.partial===1? (qty>1 ? qty:0): response.data.materialData?.qty - qty;
            let remainingQty = response.data.materialData?.qty - qty;
            if(remainingQty > 0){
              setPartialCondition(true)
            }else{
              setPartialCondition(false)  
            }
            setWarningMaterialPopup(true)
            setWarningMaterialData(response.data.materialData)
          }
        }
        else if (response.data.status === 8) {
          enqueueSnackbar(response.data.message, { variant: 'error' })
        }
           else if (response.data.message) {
          enqueueSnackbar(response.data.message, { variant: 'error' })
        } else {
          enqueueSnackbar('Error adding Jobcost', { variant: 'error' })
        }
        
        }else{
        const response = await axios.post(`${REST_API_END_POINT}project/update-material-in-jobcost`,
          { userId: user.user_id, materialBarcode, projectId, taskId,qty,initialTry:initialTry,selectedInstallation:selectedInstallation});
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' });
          setSearchMaterial('');
        }else if(response.data.status === 4){
          setConfirmAdditionalJObCost(true);
          setConfirmMessage(response.data.message);
          setMaterialData(response.data.materialData);
          console.log('dataaaaaaaaaaaaaaaaaa',response.data.materialData)
        } else if ((response.data.status === 2) || (response.data.status === 3)) {
          // setConfirmAdditionalJObCost(true);
          // setConfirmMessage(response.data.message);
          setWarningMaterialPopup(true);
          setWarningMaterialData(response.data.materialData);
          setMaterialData(response.data.materialData);

          let remainingQty = 0;
          let matData = response.data.materialData;
          if (matData?.partial == 1) {
            remainingQty = remainingQty = matData?.qty - qty;
          } else {
            remainingQty = remainingQty = matData?.unit_qty - qty;
          }
          
          if(remainingQty > 0 || (matData?.partial == 0 && remainingQty >= 0)){
            setPartialCondition(true)
          }else{
            setPartialCondition(false)  
          }
          
        } else if (response.data.status === 5) {
          if(response.data.materialData?.qty < qty){
            enqueueSnackbar("Quantity is greater than the available quantity", { variant: 'error' })
          }else{
            let remainingQty = 0;
            let matData = response.data.materialData;
            if (matData?.partial == 1) {
              remainingQty = remainingQty = matData?.qty - qty;
            } else {
              remainingQty = remainingQty = matData?.unit_qty - qty;
            }
            
            if(remainingQty > 0 || (matData?.partial == 0 && remainingQty >= 0)){
              setPartialCondition(true)
            }else{
              setPartialCondition(false)  
            }
            setWarningMaterialPopup(true);
            setWarningMaterialData(response.data.materialData);
          }
        } else if (response.data.status === 6) {
          setConfirmAdditionalJObCost(true)
          setConfirmMessage(response.data.message)
          setMaterialData(response.data.materialData)
          setRetryFirstApiCall(true)
        } else if (response.data.message) {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        } else {
          enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
        }
        let jobCostResult = response?.data?.jobCostResult?.[0] || null;
        setExistingJobCostData(jobCostResult || null)
        setFutureInstallations(response?.data?.futureInstallation || [])
        setSelectedInstallation(response?.data?.futureInstallation?.find(item => item?.location_id === jobCostResult?.for_product || item?.location_id === jobCostResult?.for_service || item?.task_id === taskId) || null)
        // setQty(1)
      }
      }
    }catch(error){
      console.log('Error in add material to jobcost', error);
    }
  }

  const handleViewAddedMaterials = async () => {
    setLoadingMaterials(true);
    try{
      const response = await axios.post(`${REST_API_END_POINT}project/view-added-material-in-task`,
        { projectId, taskId });
      if (response.data.status === 1) {
        setViewMaterialData(response.data.result);
      } else {
        enqueueSnackbar('Failed to view materials', { variant: 'error' });
        setViewMaterialData([]);
      }
    }catch(error){
      console.log('Error in add material to jobcost', error);
      setViewMaterialData([]);
    }finally{
      setLoadingMaterials(false);
    }
  }

  useEffect(() => {
    const fetchSmallSettings = async () => {
      try {
        const res = await axios.post(`${REST_API_END_POINT}print/get-small-label-settings`);
        if (res.data.status === 1) {
          setSmallLabelSettings(prev => ({
            ...prev,
            ...res.data.result
          }));
        }
      } catch (error) {
        enqueueSnackbar('Failed to load settings', { variant: 'error' });
      }
    };
  
    fetchSmallSettings();
  }, []);

  const handleSmallPrint = useReactToPrint({
    content: () => detailsRef.current,
  });


  useEffect(() => {
    const fetchSmallSettings = async () => {
      try {
        const res = await axios.post(`${REST_API_END_POINT}print/get-small-label-settings`);
        if (res.data.status === 1) {
          setSmallLabelSettings(prev => ({
            ...prev,
            ...res.data.result
          }));
        }
      } catch (error) {
        enqueueSnackbar('Failed to load settings', { variant: 'error' });
      }
    };
  
    fetchSmallSettings();
  }, []);



  const updateSmallIframeContent = () => {
    const iframe = smallIframeRef.current;
    const content = detailsRef.current;
  
    if (iframe && content) {
      const doc = iframe.contentWindow.document;
      const html = `
        <html>
          <head>
            <style>
              @page {
                size: ${smallLabelSettings.pageWidth}in ${smallLabelSettings.pageHeight}in;
                margin: 0;
              }
              html, body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                background: white;
                font-family: Arial, sans-serif;
                overflow:auto;
              }
              .label {
              position: absolute;
              top: ${smallLabelSettings.marginTop}px;
              left: ${smallLabelSettings.marginLeft}px;
              transform: scale(${smallLabelSettings.scale});
              transform-origin: top left;
              padding-top: ${smallLabelSettings.paddingTop}px;
              padding-right: ${smallLabelSettings.paddingRight}px;
              padding-bottom: ${smallLabelSettings.paddingBottom}px;
              padding-left: ${smallLabelSettings.paddingLeft}px;
              width: ${smallLabelSettings.width}in;
              height: ${smallLabelSettings.height}in;
            }
            </style>
          </head>
          <body>
            <div class="label">${content.outerHTML}</div>
          </body>
        </html>
      `;
      doc.open();
      doc.write(html);
      doc.close();
    }
  };

  // listing produnction workflows
const getAllWorkflows = async () => { 
  try {
    setWorkflowLoading(true);
    const res = await axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`);
    const sortedWorkflows = [...(res?.data?.result || [])].sort((a, b) =>
      alphanumericCompare(a?.name || '', b?.name || '')
    );
    setWorkflows(sortedWorkflows);
  } catch (error) {
    console.log(error);
    enqueueSnackbar('Failed to fetch workflows', { variant: 'error' });
    setWorkflows([]);
  } finally {
    setWorkflowLoading(false);
  }
};

// listing service workflows (status = 9 on backend)
const getAllServiceWorkflows = async () => {
  try {
    setWorkflowLoading(true);
    const res = await axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-services`);
    const sortedWorkflows = [...(res?.data?.result || [])].sort((a, b) =>
      alphanumericCompare(a?.name || '', b?.name || '')
    );
    setWorkflows(sortedWorkflows);
  } catch (error) {
    console.log(error);
    enqueueSnackbar('Failed to fetch service workflows', { variant: 'error' });
    setWorkflows([]);
  } finally {
    setWorkflowLoading(false);
  }
};

const handleOpenWorkflowDialog = async () => {
  setOpenWorkflowDialog(true);

  const desiredKind = isServiceTaskForWorkflow ? 'service' : 'product';
  if (workflowListKind !== desiredKind || !workflows?.length) {
    setWorkflowListKind(desiredKind);
    if (desiredKind === 'service') {
      await getAllServiceWorkflows();
    } else {
      await getAllWorkflows();
    }
  }
};

useEffect(() => {
  const isAllCompleted =
    Array.isArray(data) &&
    data.length > 0 &&
    data.every((item) => Number(item.status) === 3);
  setAllSubtasksCompleted(isAllCompleted);
}, [data]);

useEffect(() => {
  console.log('useEffect==taskData',taskData)
  console.log('useEffect==workflows',workflows)
  if (!taskData || !workflows?.length) return;
  const currentWorkflowId = isServiceTaskForWorkflow
    ? (taskData?.request_service_workflow ??
      taskData?.service_workflow ??
      taskData?.workflow ??
      null)
    : (taskData?.customer_order_product_workflow ??
      taskData?.workflow ??
      taskData?.service_workflow ??
      null);
  const current = workflows.find(
    (w) => Number(w?.id) === Number(currentWorkflowId)
  ) || null;
  setSelectedWorkflow(current);
}, [taskData, workflows]);


const handleRequestApplyWorkflow = () => {
  if (!selectedWorkflow) {
    enqueueSnackbar('Please select a workflow', { variant: 'warning' });
    return;
  }
  const currentWorkflowId = isServiceTaskForWorkflow
    ? (taskData?.request_service_workflow ??
      taskData?.service_workflow ??
      taskData?.workflow ??
      null)
    : (taskData?.customer_order_product_workflow ??
      taskData?.workflow ??
      taskData?.service_workflow ??
      null);

  // if (Number(selectedWorkflow?.id) === Number(currentWorkflowId)) {
  //   enqueueSnackbar("You didn't change the workflow", { variant: 'info' });
  //   return;
  // }
  setOpenWorkflowConfirmDialog(true);
};


// sending payload to update project task after selecting a workflow from dropdown
const handleConfirmApplyWorkflow = async () => {
  try {
    if (!taskData?.customer_order_product_id) {
      enqueueSnackbar(
        isServiceTaskForWorkflow
          ? 'Unable to map this task to a service row'
          : 'Unable to map this task to a sales order product',
        { variant: 'error' }
      );
      return;
    }

    setWorkflowSaving(true);
    setOpenWorkflowConfirmDialog(false);

    const payload = isServiceTaskForWorkflow
      ? {
          requestServiceId: Number(taskData?.customer_order_product_id),
          workflowId: Number(selectedWorkflow?.id),
          userId: user?.user_id,
          request_id:details?.request_id,
        }
      : {
          customerOrderProductId: Number(taskData?.customer_order_product_id),
          workflowId: Number(selectedWorkflow?.id),
          userId: user?.user_id,
          request_id:details?.request_id,
        };

    const response = await axios.post(`${REST_API_END_POINT}project/update-task-workflow`, payload);

    if (response?.data?.status === 1) {
      enqueueSnackbar('Workflow updated successfully', { variant: 'success' });
      setOpenWorkflowDialog(false);
      setRefresh(!refresh);
      setFetchData(true);
      onDataChange?.();
    } else {
      enqueueSnackbar(response?.data?.message || 'Failed to update workflow', { variant: 'error' });
    }
  } catch (error) {
    console.log(error);
    enqueueSnackbar('Error updating workflow', { variant: 'error' });
  } finally {
    setWorkflowSaving(false);
  }
};
  return (
    <Grid  spacing={3}>
      <Grid item xs={12}>
        {(user.user_type !== 3 && 
        (details?.job_category_name == 'Service only' ||
        (currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab!="Completed" && details?.status != 3)) &&
        currentTab!="Hold" && details?.hold != 1 && !isMirrored && details?.status != 9
      ) &&
        <Stack alignItems='center'  flexDirection={isSmallScreen ? 'column' : 'row'} >
          <Stack justifyContent='space-between' alignItems='center' flexDirection='row' gap={2} sx={{mb:2}} >
            <TextField
              size='small'
              type="number"
              label={'Enter Qty'}
              placeholder='Enter Qty'
              value={qty || ''}
              inputProps={{ min: 0.01, step: "any" }}
              onChange={(e)=>{
                setQty(e.target.value);
              }}
              onBlur={(e) => {
                let val = Number(e.target.value);
                if (e.target.value === '' || isNaN(val) || val <= 0) {
                  setQty(1);
                } else {
                  // This removes leading/trailing zeroes once they leave the field
                  setQty(val);
                }
              }}
              onKeyDown={(event) => {
                if (event.key === '-' || event.key === '+') {
                  event.preventDefault();
                }
              }}
              onWheel={(e) => {
                e.target.blur()
                e.preventDefault()
              }}
            />
            <TextField
              fullWidth
              size='small'
              label={'Scan Material / Product'}
              placeholder='Scan Material / Product'
              value={searchMaterial}
              onChange={(e)=>{
                setSearchMaterial(e.target.value);
                handleAddMaterialToJobCost(e.target.value)
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                )
              }}
            />
            
</Stack>
<Stack justifyContent='space-between' alignItems='center' flexDirection='row' gap={2} sx={{mb:2}} >
<>
      {/* Icon Button to trigger QR scanner */}
 {/* QR Code Scanner Icon */}
 <IconButton onClick={() => setOpenQRScanner(true)}>
        <QrCodeScanner sx={{ fontSize: "30px" }} />
      </IconButton>

      {/* Dialog for QR Scanner */}
      <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
        <DialogTitle>Scan QR Code</DialogTitle>
        <DialogContent>
          <div id="reader" style={{ width: "100%" }}></div>
        </DialogContent>
      </Dialog>
    </>

            <Tooltip title='View Added Materials'>
            <Button
              variant="contained"
              sx={{width:'270px'}}
              type="submit"
              onClick={()=>{handleViewAddedMaterials(); setViewMaterial(true);}}
              startIcon={
                <Stack>
                  <Visibility />
                </Stack>
              }
            >
              View Materials
            </Button>
            </Tooltip>
          </Stack>
          </Stack>
          }
          {/* New Button for View Product Formula */}
            {/* <Tooltip title='View Product Formula'> */}
            {/* {taskData?.product_id && taskData?.recipe_id ? (
                <Button
                  variant="contained"
                  sx={{width:'270px'}}
                  type="button"
                  onClick={() => setOpenViewProductFormulaModal(true)}
                  startIcon={
                    <Stack>
                      <Visibility />
                    </Stack>
                  }
                >
                  View Product Formula
                </Button>
              ) : ''} */}
            {/* </Tooltip> */}
          {/* {(data?.length > 0) && <Stack justifyContent='space-between' alignItems='center' flexDirection='row'>
            <Stack justifyContent='flex-start' alignItems='center' flexDirection='row'>
              <Typography  variant='subtitle1'>{(checkedItems?.length > 0) && checkedItems?.length+' selected' }</Typography>
            </Stack>
            { (user.user_type !== 3 && currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab!="Completed" && currentTab!="Hold" && details?.status != 3 && details?.hold != 1) &&
            <Stack justifyContent='flex-end' alignItems='center' flexDirection='row'>
              <Card>
                <Stack justifyContent='flex-end' alignItems='center' flexDirection='row' sx={{m:2}}>
                  <Stack justifyContent='center' alignItems='center' flexDirection='column' sx={{mr:2}}>
                    <Typography variant="h6" sx={{textAlign: 'center',color:theme.palette.secondary}}>
                    {"Date"} </Typography>
                    <Typography variant="h5" sx={{textAlign: 'center',color:theme.palette.secondary}}>
                    {moment().format('MM/DD/YYYY')}</Typography>
                  </Stack>
                  <Stack justifyContent='center' alignItems='center' flexDirection='column'>
                  <Typography variant="h6" sx={{textAlign: 'center',color:'#fc8c03'}}>
                  {"Work Time"} </Typography>
                  {isLoggedIn ? 
                    // (elapsedTime!==0) ?
                      <Typography variant="h4" sx={{textAlign: 'center',color:'#fc8c03'}}>
                      {hours+':'+minutes+':'+seconds}</Typography> 
                    // :
                    // <Stack sx={{mr:2,textAlign: 'center',mb: 2}}>
                    //   <CircularProgress color="warning" variant="indeterminate" size='20px' />
                    // </Stack>
                  : <Typography variant="h4" sx={{textAlign: 'center',color:'#fc8c03'}}>
                      {'00:00:00'}</Typography>  }
                  </Stack>
                </Stack>
              </Card>
              {projectData ?
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isSelectAll}
                  // onClick={()=>{handleClockInOut()}}
                  onClick={()=>{
                    if(projectData?.status == 1){
                      enqueueSnackbar('Clock-in is not allowed in Preproduction', { variant: 'warning' })
                    }else{
                      if(isLoggedIn || taskData?.service_id != null){
                        handleClockInOut()
                      }else{
                        if (checkedItems?.length > 0) {
                          setOpenService(true)
                        } else {
                          enqueueSnackbar("Please select atleast one sub task", { variant: 'error' })
                        }
                      }
                    }
                  }}
                  sx={{ mb: 2,ml:2 }}
                  startIcon={
                    <Stack>
                      {isLoggedIn ? <Logout /> : <Login />}
                    </Stack>
                  }
                >
                  {isLoggedIn ? "Clock Out" : "Clock In"}
                </Button>
              : '' }
            </Stack>}
          </Stack>} */}
          { (user.user_type !== 3 && currentTab != 'Installs' && !isMirrored && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab!="Completed" && currentTab!="Hold" && details?.status != 3 && details?.hold != 1 && details?.status != 9 && !allSubtasksCompleted) &&
          <Box width={'100%'} display={'flex'} justifyContent={ (currentTab == "Pre-Production") ? 'space-between' : 'flex-end'} mb={2}>
            {(currentTab == "Pre-Production" && data?.length > 0) &&
            <Box display={'flex'} >
              <Checkbox sx={{cursor:'pointer'}}
                disabled={isLoggedIn || !hasJobPermission ? true : false}
                checked={isSelectAll}
                onChange={() => {(isLoggedIn || !hasJobPermission) ? null : handleSelectAll()}}
                color="primary"
              />
              <Typography sx={{mt:1}}>Select All</Typography>
            </Box>
            }
            {isSelectAll ?
              <TextField
                select
                size="small"
                value={(projectData?.project_category === 11 ? option.filter(opt => opt.id === 1 || opt.id === 3) : option)?.find(opt=>opt.id==getMostCommonStatus())?.value || ''}
                sx={{
                  minWidth: { lg: '50%', md: '40%', sm: '30%' },
                  // height: '30px !important',
                  background: colors[getMostCommonStatus()],
                  color:'blue',
                  borderRadius: 1,
                  border: 'none',
                  '&:hover': {
                    // transform: 'scale(1.02)',
                    border: 'none',
                  },
                }}
              >
                {(projectData?.project_category === 11 ? option.filter(opt => opt.id === 1 || opt.id === 3) : option).map((optio) => (
                  <MenuItem
                    disabled={(user.user_type == 3 || currentTab == 'Installs' || currentTab == 'Pickup' || currentTab == 'Shipping' || currentTab == 'Completed' || details?.status == 3 || details?.hold == 1 || !hasJobPermission) ? true : false}
                    onClick={() => {
                      handleUpdateAllStatus(optio.id)
                    }}
                    key={optio.value}
                    value={optio.value}
                  >
                    {optio.value}
                  </MenuItem>
                ))}
              </TextField>
            :
              // <Button onClick={() => {
              // setAdd(true);
              // }} 
              // variant="outlined"
              // disabled={isSelectAll}
              // startIcon={<Icon icon={plusFill} />}>Add Subtask</Button>
        
              
              // change workflow ui
  <Stack direction="row" spacing={1}>
    <Button
      onClick={handleOpenWorkflowDialog}
      variant="contained"
      disabled={isSelectAll || workflowSaving || !changeWorkflowPermission}
      sx={{marginRight:'10px'}}
    >
      Change Workflow
    </Button>

    <Button
      onClick={() => {
        setAdd(true);
      }}
      variant="outlined"
      disabled={isSelectAll}
      startIcon={<Icon icon={plusFill} />}
    >
      Add Subtask
    </Button>
  </Stack>
            }
          </Box>}
        {data?.length ? data.map((post, index) => {
          // Get stopwatch state for the current subtask
          const currentStopwatchState = subtaskStopwatches[post.ID] || { stopwatchData: null, isRunning: false, elapsedTime: 0 };
          const { stopwatchData, isRunning, elapsedTime } = currentStopwatchState;

          const safeElapsed = Math.max(0, Math.floor(Number(elapsedTime) || 0));
          const hours = String(Math.floor(safeElapsed / 3600)).padStart(2, '0');
          const minutes = String(Math.floor((safeElapsed % 3600) / 60)).padStart(2, '0');
          const seconds = String(safeElapsed % 60).padStart(2, '0');

          return(
        // <Grid key={index} item xs={12} sm={6}>
          <Card key={index}
            sx={{
              minWidth: 275,
              mb: 2,
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.02)',
              },
              backgroundColor: checkedItems.includes(String(post.ID)) ? theme.palette.divider : null,
            }}
          >
            {/* <Box className={classes.checkboxContainer}>
              <Checkbox sx={{cursor:'pointer'}}
                checked={checkedItems?.includes(String(post?.ID)) ? true : false}
                onChange={() => {isLoggedIn ? null : handleCheckboxChange(String(post.ID))}}
                color="primary"
              />
            </Box> */}
            
            <Box sx={{ px: 2, py: 1, textAlign: 'center', justifyContent: 'center' }}>
            { (user.user_type !== 3 && currentTab != 'Installs' && !isMirrored && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab!="Completed" && currentTab!="Hold" && details?.status != 3  && details?.hold != 1 && details?.status != 9)&&
              <Stack
                direction={'row'}
                // justifyContent={projectData?.status ==1 ? "end":'space-between'}
                justifyContent={"end"}
                alignItems={'center'}
              >
                {/* {
                  projectData?.status ==1 ? ""
                  :
                  <Checkbox sx={{cursor:'pointer'}}
                  checked={checkedItems?.includes(String(post?.ID)) ? true : false}
                  onChange={() => {(isLoggedIn) ? null : handleCheckboxChange(String(post.ID))}}
                  // onChange={() => {(isLoggedIn || post.status==3) ? null : handleCheckboxChange(String(post.ID))}}
                  color="primary"
                  />
                } */}
     {isSelectAll || !canShowSubtaskMenu(post) ? null : (
  <UserMoreMenu
    onEdit={() => {
      if (!hasEditSubtaskPermission) {
        enqueueSnackbar('You do not have permission to edit the subtask', {
          variant: 'error',
        });
        return;
      }

      if (isLoggedIn) {
        enqueueSnackbar('Please clockout to make changes', {
          variant: 'error',
        });
        return;
      }

      handleFetchSubTask(post.ID);
    }}
    onDelete={() => {
      if (!hasDeleteSubtaskPermission) {
        enqueueSnackbar('You do not have permission to delete the subtask', {
          variant: 'error',
        });
        return;
      }

      if (isLoggedIn) {
        enqueueSnackbar('Please clockout to delete the subtask', {
          variant: 'error',
        });
        return;
      }

      handleDeleteClick(post.ID);
    }}
  />
)}
  </Stack>}
            </Box>
            <Box sx={{ px: 2,pb: 3, justifyContent: 'space-between' }}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Typography variant="h6" align="center" sx={{cursor:'pointer'}}
                  onClick={()=>(!isMirrored) ? handleFetchSubTaskView(post.ID) : null}>
                  {post.name}
                </Typography>
                {/* <Stack>
                <Typography
                    variant="overline"
                    sx={{ mt: 3, display: 'block', color: 'text.secondary' }}
                  >
                    Description
                  </Typography>
                <Typography variant="body" align="center">
                  {post.description}
                </Typography>
                </Stack> */}
                {/* {(currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && details?.status != 3 && details?.hold != 1 && currentTab!="Completed" && currentTab!="Hold") && */}
                {/* {(details?.hold != 1 && currentTab!="Completed" && currentTab!="Hold") && */}
                {
                  details?.project_category !== 12 ?
                <Typography variant="body" align="center">
                  {post?.total_hours ? 'Total Hours : '+post?.total_hours : 'Total Hours : 00:00:00'}
                </Typography> :''
                }
                {/* // } */}
               {/* {(currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && details?.status != 3 && details?.hold != 1 && currentTab!="Completed" && currentTab!="Hold") && <TextField */}
               {(currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && details?.hold != 1 && currentTab!="Completed" && currentTab!="Hold") && 
               <>
                 {details?.status != 9 ? <TextField
                      select
                      disabled={(checkedItems?.includes(String(post?.ID)) || !hasJobPermission || isSelectAll || projectData?.status == 3||details?.status == 9 ||details?.status == 1 || (details?.project_category == 15 && details?.for_parent_facility == 1 && details?.is_split_order == 1 && taskData?.status == 3) || !canShowSubtaskMenu(post) || allSubtasksCompleted ) ? true : false}
                      // disabled={(checkedItems?.includes(String(post?.ID)) || isSelectAll || post.status==3) ? true : false}
                      size="small"
                      value={(projectData?.project_category === 11 ? option.filter(opt => opt.id === 1 || opt.id === 3) : option).find(opt=>opt.id===post.status)?.value || ''}
                      sx={{
                        minWidth: { lg: '50%', md: '40%', sm: '30%' ,color:"#fff"},
                        // height: '30px !important',
                        background: colors[post.status],
                        // color:'blue',
                        borderRadius: 1,
                        border: 'none',
                        '&:hover': {
                          // transform: 'scale(1.02)',
                          border: 'none',
                        },
                      }}
                    >
                      {(projectData?.project_category === 11 ? option.filter(opt => opt.id === 1 || opt.id === 3) : option).map((optio) => (
                        <MenuItem
                          disabled={(user.user_type == 3 || currentTab == 'Installs' || currentTab == 'Pickup' || currentTab == 'Shipping' || currentTab == 'Completed' || details?.status == 3 || details?.hold == 1 || isMirrored||details?.status == 1 || !hasJobPermission)? true : false}
                          onClick={() => {
                            // handleUpdateStatus(post.ID,optio.id)
                            if (optio.id === 3) {
                              const members = post?.teamMembers
                              handleClockinTime(members, post.ID, true)
                            } else {
                              handleUpdateStatus(post.ID,optio.id)
                            }
                            // setValue(optio)
                          }}
                          key={optio.value}
                          value={optio.value}
                        >
                          {optio.value}
                        </MenuItem>
                      ))}
                  </TextField>:
                  <Typography variant="body" align="center" sx={{color:'red'}}>
                    Rejected
                  </Typography>
                  }
               </>
                }
              </Stack>
            </Box>
           {/* {(currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && details?.status != 3 && details?.hold != 1 && currentTab!="Completed" && currentTab!="Hold") && <Box sx={{ marginLeft: 2, marginRight: 2 }}>
                  <Typography
                    variant="overline"
                    sx={{ mt: 3,display: 'block', color: 'text.secondary' }}
                  >
                    Completion
                  </Typography>
                
                  <Sliderw
                    aria-label="Percentage"
                    defaultValue={post.complete}
                    getAriaValueText={valuetext}
                    onChange={(event, value) => updateStatus(event, post.ID)}
                    valueLabelDisplay="auto"
                    disabled={(user.user_type == 3 || currentTab == 'Installs' || currentTab == 'Pickup' || currentTab == 'Shipping' || currentTab == 'Completed' || details?.status == 3 || details?.hold == 1) ? true : false}
                    //  step={10}
                    marks
                    min={0}
                    max={100}
                  />
            </Box>} */}
            <Box sx={{ display: 'flex',justifyContent:'space-between', alignItems: 'center', p: 2, }}>    
            {/* {post.status===3 && (
            <Stack
                direction={'row'}
                justifyContent={'flex-end'}
                alignItems={'center'}
              >
                <FinishedProductmenu 
                url={`${BASE_URL}view-sub-task/`}
                id={post.ID}
                 useIcon={true}/>
                </Stack>
            )} */}
             <Stack>    
              <Typography variant="subtitle2">
                   Job Members
                    </Typography>             
                    <AvatarGroup max={4}>
                     {post.teamMembers?.slice(0, 3).map((row)=>( 
                        <Tooltip key={row.id} title={row.name}>             
                      <Avatar src={row.profile_pic} alt={row.name} />
                      </Tooltip>                   
                     ))}
                     {post.teamMembers?.length > 3 && (
                       <Tooltip title="View all members">
                         <Avatar
                           onClick={() => {
                             setPopupMembers(post.teamMembers || []);
                             setOpenMembersPopup(true);
                           }}
                           sx={{
                             cursor: 'pointer',
                             bgcolor: '#c8e6c9',
                             color: '#1b5e20',
                             fontSize: 14,
                           }}
                         >
                           +{post.teamMembers.length - 3}
                         </Avatar>
                       </Tooltip>
                     )}
                    </AvatarGroup>
                  </Stack>
                   {/* Stopwatch UI */}
                   <Stack direction="row" spacing={1} alignItems="center">
                     <Typography variant="body1">Stopwatch:</Typography>
                     {editingStopwatchId === stopwatchData?.id ? (
                       <TextField
                         value={editedTime}
                         onChange={(e) => setEditedTime(e.target.value)}
                         size="small"
                         variant="outlined"
                         sx={{ width: 120, '& input': { textAlign: 'center' } }}
                       />
                     ) : (
                       <Typography
                         variant="h6"
                        //  onDoubleClick={() => elapsedTime > 0 && handleEditStopwatch(stopwatchData?.id, elapsedTime)}
                         sx={{ cursor: elapsedTime > 0 ? 'pointer' : 'default' }}
                       >
                         {secondsToHHMMSS(elapsedTime)}
                       </Typography>
                     )}
                     {!isRunning && (
                       editingStopwatchId === stopwatchData?.id ? (
                         <Button
                           variant="contained"
                           color="success"
                           size="medium"
                           onClick={() => handleSaveEditedTime(stopwatchData.id, post.ID)}
                           sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                         >
                           <Check fontSize="small" />
                         </Button>
                       ) : (
                        null
                        //  <Button
                        //    variant="outlined"
                        //    size="medium"
                        //    onClick={() => handleEditStopwatch(stopwatchData?.id, elapsedTime)}
                        //    disabled={elapsedTime === 0}
                        //    sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                        //  >
                        //    <Edit fontSize="small" />
                        //  </Button>
                       )
                     )}
                     {isRunning ? (
                       <Button
                         variant="contained"
                         color="error"
                         onClick={() => stopStopwatch(stopwatchData.id, post.ID)}
                         size="medium"
                         sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                       >
                         Stop
                       </Button>
                     ) : (
                       <Button
                         variant="contained"
                         color="success"
                         onClick={() => startStopwatch(post.ID)}
                         size="medium"
                         sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                       >
                         Start
                       </Button>
                     )} 
                     
                      {stopwatchData && (stopwatchData.end_time !== null || isRunning) && (
                        <Button
                          variant="outlined"
                          color="warning"
                          onClick={() => clearStopwatch(post.ID)}
                          size="medium"
                          sx={{ minWidth: 'auto', px: 1, py: 0.6 }}
                        >
                          <Replay fontSize="small" sx={{ animation: 'resetAnimation 1s infinite' }} />
                        </Button>
                      )}
                   </Stack>
                   {/* End Stopwatch UI */}
                  {
                    (details?.project_category !== 12 && (post?.teamMembers.length > 0 && (currentTab!="Completed" && currentTab!="Hold") && !isMirrored)) ?
                    <Button variant='outlined' onClick={()=>handleClockinTime(post?.teamMembers,post.ID)}>Work Time</Button>
                  :''
                  }
                  {/* {
                    (details?.project_category !== 12 && (post?.teamMembers.length > 0 && post?.status === 3 && (currentTab!="Completed" && currentTab!="Hold"))) ?
                    <Button variant='outlined' onClick={()=>handleClockinTime(post?.teamMembers,post.ID)}>Work Time</Button>
                  :''
                  } */}
            </Box>
            <ConfirmationPopup open={deleteStates[post.ID]} handleClick={()=>handleDeleteSubTask(post.ID)} message={'Want to Delete This SubTask'} handleClose={()=>handleCancelDelete(post.ID)}/>
          </Card>
          )
        }) :
        <Box
          width={'100%'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          py={15}
        >
          No subtasks found 
        </Box>}
      </Grid>
      <ConfirmationPopup
       open={confirmAdditionalJObCost} 
       handleClick={()=>handleConfirmAdditionalJobCost()} 
       message={confirmMessage} 
       handleClose={()=>{setConfirmAdditionalJObCost(false);setConfirmMessage('');setSearchMaterial('')}}
       projectCategory={details?.project_category}
       futureInstallations={futureInstallations}
       existingJobCostData={existingJobCostData}
       includeChooseInstallation={details?.project_category !== 12}
       selectedInstallation={selectedInstallation}
       setSelectedInstallation={setSelectedInstallation}
       />
      <WarningMaterialPopup
        open={warningMaterialPopup}
        onClose={handleWarningClose}
        onConfirm={handleWarningConfirm}
        materialName={warningMaterialData?.name || 'Material'}
        qty={qty || 1}
        existingJobCostData={existingJobCostData}
        selectedInstallation={selectedInstallation}
        includeChooseInstallation={details?.project_category !== 12}
        setSelectedInstallation={setSelectedInstallation}
        isSubTask={true}
        futureInstallations={futureInstallations}
        projectCategory={details?.project_category}
        partialCondition={partialCondition}
        // isSubTask={true}
        // partialCondition={warningMaterialData?.partial===1? qty>1 ? true:false:partialCondition}
        addPartialStock={addPartialStock}
        setAddPartialStock={setAddPartialStock}
      />
      <ConfirmationPopup
        open={openPartialConfirm}
        message={`You want to move ${(partialTargetProduct?.name || partialTargetProduct?.product_name || 'this product')} to partial!`}
        handleClose={() => setOpenPartialConfirm(false)}
        handleClick={handleMoveToPartialFromWarning}
      />
      <Modal
        modalTitle={`Move ${partialTargetProduct?.partial==1 ? "Partial" : "Finished"} Product to Partial`}
        open={partialModalOpen}
        handleClose={handleClosePartialModal}
      >
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={8}>
            <Stack spacing={3}>
              <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                {/* <Typography variant="body1" color={'red'}>Maximum Partial product qty: {partialTargetProduct?.partial==1 ? qty : partialTargetProduct?.ogRemainingQty ?? partialTargetProduct?.qty ?? 0}</Typography> */}
                {partialTargetProduct?.partial==0 &&<Typography variant="body1" color={'red'}>Maximum Partial product qty: {partialTargetProduct?.ogRemainingQty ?? partialTargetProduct?.qty ?? 0}</Typography>}
                <TextField
                  fullWidth
                  label={`${convertionUnitName} Qty to be moved`}
                  type="number"
                  onKeyPress={(event) => {
                    if (event.key === '0' && event.target.value === '0') {
                      event.preventDefault()
                    }
                    if (event.key === '-' || event.key === '+' || event.key === 'e') {
                      event.preventDefault()
                    }
                  }}
                  disabled={partialTargetProduct?.partial==1 ? true:false}
                  inputProps={{ style: partialTargetProduct?.partial==1 ? { WebkitTextFillColor: 'rgba(255,255,255,0.38)', color: 'rgba(255,255,255,0.38)' } : {} }}
                  onWheel={(e) => {
                    e.target.blur()
                    e.preventDefault()
                  }}
                  value={partialTargetProduct?.partial==1 ?partialTargetProduct?.ogRemainingQty : movingQty}
                  onChange={(e) => {
                    const maxremQty = partialTargetProduct?.partial==1 ? Number(partialTargetProduct?.remainingQty): Number(partialTargetProduct?.remainingQty)
                    const maxQty = maxremQty;
                    console.log('fvfvfvfv maxQtyyy 1',maxQty)
                    console.log('fvfvfvfv qty qty',qty)
                    console.log('fvfvfvfv maxremQtyyy 2',maxremQty)
                    let inputQty = e.target.value || 1
                    if (partialTargetProduct?.partial==1 ? Number(inputQty) < 0 : Number(inputQty) < 1) {
                      inputQty = 1
                    }
                    if (maxQty > 0 && Number(inputQty) > maxQty) {
                      inputQty = maxQty
                    }
                    console.log('fvfvfvfv inputQtyyy 1',inputQty)
                    setMovingQty(inputQty)
                    // Set Conversion Qty to match Qty to be moved
                    setConvertionQty(inputQty)
                    const baseUnitCost = Number(
                      partialTargetProduct?.unit_cost ??
                        partialTargetProduct?.material_unit_cost ??
                        partialTargetProduct?.unit_price ??
                        partialTargetProduct?.unitPrice ??
                        0
                    )
                    // const unitCost = inputQty > 0 ? baseUnitCost / inputQty : 0
                    const unitCost = inputQty > 0 ? partialTargetProduct?.partial==1 ? baseUnitCost : (baseUnitCost / partialTargetProduct?.qtyForPrice) : 0
                    setConvertionUnitPrice(unitCost)
                    setConvertionTotalPrice(unitCost * inputQty)
                    setPartialErrors((prev) => ({ ...prev, movingQty: '' }))
                  }}
                  error={!!partialErrors.movingQty}
                  helperText={partialErrors.movingQty}
                />

                <TextField
                  fullWidth
                  label="Size"
                  type="text"
                  value={partialSize}
                  onChange={(e) => setPartialSize(e.target.value)}
                />

                <Autocomplete
                  fullWidth
                  id="partial-conversion-unit"
                  options={unitType ? UNITS.filter(unit => unit.id === unitType) : UNITS}
                  value={unitType ? UNITS.find(unit => unit.id === unitType) : convertionUnit}
                  onChange={(event, newValue) => {
                    setConvertionUnit(newValue)
                    setPartialErrors((prev) => ({ ...prev, convertionUnit: '' }))
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      error={!!partialErrors.convertionUnit}
                      helperText={partialErrors.convertionUnit}
                      label="Select a conversion unit"
                    />
                  )}
                  getOptionLabel={(option) => (option.name ? option.name : '')}
                />

                {/* <TextField
                  fullWidth
                  label={convertionUnit ? `${convertionUnit?.short_name} Qty` : 'Conversion Qty'}
                  type="number"
                  onKeyPress={(event) => {
                    if (event.key === '0' && event.target.value === '0') {
                      event.preventDefault()
                    }
                    if (event.key === '-' || event.key === '+' || event.key === 'e') {
                      event.preventDefault()
                    }
                  }}
                  value={convertionQty || ''}
                  onChange={(e) => {
                    const inputValue = parseFloat(e.target.value) || 0
                    const baseUnitCost = Number(
                      partialTargetProduct?.unit_cost ??
                        partialTargetProduct?.material_unit_cost ??
                        partialTargetProduct?.unit_price ??
                        partialTargetProduct?.unitPrice ??
                        0
                    )
                    const unitCost = inputValue > 0 ? baseUnitCost / inputValue : 0
                    setConvertionQty(inputValue)
                    setConvertionUnitPrice(unitCost)
                    setConvertionTotalPrice(unitCost * inputValue)
                    setPartialErrors((prev) => ({ ...prev, convertionQty: '' }))
                  }}
                  error={!!partialErrors.convertionQty}
                  helperText={partialErrors.convertionQty}
                /> */}

                {/* <TextField
                  fullWidth
                  label={'Unit Cost'}
                  type="number"
                  disabled
                  value={convertionUnitPrice ? parseFloat(convertionUnitPrice || 0)?.toFixed(2) : 0}
                /> */}

                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={autoFill}
                      onChange={(event) => setAutoFill(event.target.checked)}
                    />
                  }
                  label="Automate the process"
                />
              </Stack>

              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="submit" variant="contained" onClick={handleSubmitPartialFromWarning}>
                  Move to Partial
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClosePartialModal}
                  sx={{ marginLeft: '10px' }}
                >
                  Cancel
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Modal>

      {/* select produnction workflow box and dropdown autocomplete */}
      <Dialog open={openWorkflowDialog} onClose={() => setOpenWorkflowDialog(false)} fullWidth maxWidth="sm">
  <DialogTitle>{isServiceTaskForWorkflow ? 'Select a Service Workflow' : 'Select a Production Workflow'}</DialogTitle>
  <DialogContent>
    <Autocomplete
      options={workflows || []}
      loading={workflowLoading}
      value={selectedWorkflow}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, value) => Number(option?.id) === Number(value?.id)}
        onChange={(event, newValue) => setSelectedWorkflow(newValue)}
      filterOptions={(options, { inputValue }) =>
        options.filter(option =>
          (option?.name || '').toLowerCase().includes(inputValue.toLowerCase())
        )
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={isServiceTaskForWorkflow ? 'Service Workflow' : 'Production Workflow'}
          margin="dense"
          fullWidth
          variant="outlined"
        />
      )}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenWorkflowDialog(false)} color="inherit">
      Cancel
    </Button>
    <Button
      onClick={handleRequestApplyWorkflow}
      variant="contained"
      disabled={workflowSaving || workflowLoading || !selectedWorkflow}
    >
      {workflowSaving ? 'Applying...' : 'Apply Workflow'}
    </Button>
  </DialogActions>
</Dialog>
<Dialog
  open={openWorkflowConfirmDialog}
  onClose={() => setOpenWorkflowConfirmDialog(false)}
  fullWidth
  maxWidth="sm"
>
  {/* confirmation box before applying workflow */}
  <DialogTitle>Are you sure you want to continue?</DialogTitle>
  <DialogContent>
    <DialogContentText
    sx={{mt:3}}
    >
      The clocked-in times will be reset
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button
      variant="outlined"
      color="inherit"
      onClick={() => setOpenWorkflowConfirmDialog(false)}
      disabled={workflowSaving}
    >
      No, Go Back
    </Button>
    <Button
      variant="contained"
      onClick={handleConfirmApplyWorkflow}
      disabled={workflowSaving}
    >
      {workflowSaving ? 'Saving...' : 'Yes, Update Workflow'}
    </Button>
  </DialogActions>
</Dialog>



      <AddTask title={isEdit ? view?'View SubTask':'Edit SubTask' : 'Add SubTask'} data={singleData} setData={setSingleData} setFetchData={setFetchData} projectMembers={projectMembers} taskId={taskId} add={add || isEdit} setAdd={isEdit ? setIsEdit : setAdd} projectId={projectId} view={view} setView={setView} skillsandServices={skillsandServices} details={details} isTimeAndMaterial={details?.project_category === 12} refresh={refresh} setRefresh={setRefresh} />
      <ProjectStatusPopup open={openPopup} onClose={handleClosePopup} staffTimeLogData={staffTimeLog} handleClockInOut={handleClockInOut} autoClockoutTime={autoClockoutTime} />
      <Modal
      open={viewMaterial ? true : false}
      handleClose={() => {
        setViewMaterialData([]);
        setViewMaterial(false);
      }}
      modalTitle={'Materials added'}
    >
      {loadingMaterials ?
      (
        <CircularProgress color="primary" variant="indeterminate" />
      ) : (
        viewMaterialData?.length > 0 ?
        <TableContainer component={Paper}>
          <Table>
              <TableHead>
                  <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>Barcode</TableCell>
                      <TableCell>Product Name</TableCell>
                      <TableCell>Unit Cost</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Total</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                  {viewMaterialData?.map((material, index) => (
                      <TableRow key={material.id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{material.barcode}</TableCell>
                          <TableCell>{material.productName}</TableCell>
                          <TableCell>{material.unit_price}</TableCell>
                          <TableCell>{material.quantity}</TableCell>
                        <TableCell>{parseFloat(material.unit_price * material.quantity).toFixed(2)}</TableCell>
                          {/* <TableCell>{material.total}</TableCell> */}
                      </TableRow>
                  ))}
              </TableBody>
          </Table>
        </TableContainer>
        :
        <Typography>No materials added</Typography>
      )}
    </Modal>

    <ViewProductFormulaModal
      open={openViewProductFormulaModal}
      onClose={() => setOpenViewProductFormulaModal(false)}
      formulaId={taskData?.recipe_id}
      selectedTab={details?.project_type_name?.toLowerCase().includes('production') ? 'production' : details?.project_type_name?.toLowerCase().includes('traffic') ? 'traffic' : 'split'}
      explodedPermissions={explodedPermissions}
      user={user}
    />
      {finalTaskStatus === 3 && ((details?.project_category === 15 && details?.is_split_order !== 1) || (projectData?.project_category === 15 && projectData?.is_split_order !== 1)) ? (
        <Dialog open={openPopupComplete} onClose={() => setOpenPopupComplete(false)}>
          <DialogContent>
            <Stack direction="column" spacing={2}>
              <Typography variant='h6'>Are you sure you want to complete this Job?</Typography>
              <Alert severity='warning'>If this job is completed, stock will be added to the selected Catalog. Once completed, this job & sales order will move directly to the Completed tab.</Alert>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' color='inherit' onClick={() => setOpenPopupComplete(false)}>No</Button>
            <Button
              variant="contained"
              sx={{ boxShadow: 'none' }}
              onClick={() => {
                setOpenPopupComplete(false);
                handleFinalTaskUpdateStatus();
              }}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <ConfirmationPopup
          isComplete={true}
          loading2={loadingInstall}
          setCompleteStatus={setCompleteStatus}
          noServiceNoTask={details?.noServiceNoTask}
          projectCategory={projectData?.project_category}
          projectId={projectId}
          details={details}
          projectTasks={finalTaskId ? [taskData] : []}
          open={openPopupComplete}
          handleClick={(stockData) => {
            if(finalTaskStatus === 9){
              convertJObToInstallation(stockData)
            }else{
              handleFinalTaskUpdateStatus(stockData);
            }
          }}
          hideCancel={true}
        />
      )}

    {/* <ConfirmationPopup
      isComplete={true}
      loading2={loadingInstall}
      setCompleteStatus={setCompleteStatus}
      noServiceNoTask={details?.noServiceNoTask}
        open={openPopupComplete}
        handleClick={() => {
          handleFinalTaskUpdateStatus()
          // convertJObToInstallation(user.user_id)
          
        }}
        hideCancel={true}
        // handleClose={() => {
        //   setOpenPopupComplete(!openPopupComplete)
        // }}
        // message={`All tasks and subtasks have been moved to the ${status?.value} state`}
      />
      {/* {
        filteredClockInServices?.length > 0 ? */}
          <Dialog
            aria-describedby="alert-dialog-slide-description"
            TransitionComponent={Transition}
            transitionDuration={500}
            open={openService}
            PaperProps={{
              sx: {
                width: { xs: '90%', sm: '60%' , md:'70%' },
                p: 2,
                borderRadius: 2
              }
            }}
          >
            <DialogContent
              sx={{
                mt: 1,
                px: 2,
                overflowY: 'auto',
                overflowX: 'auto',
                scrollbarWidth: 'thin', 
                '&::-webkit-scrollbar': {
                  width: '0.75rem',
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: 'inset 0 0 6px rgba(110, 108, 108, 0.32)',
                  webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(110, 108, 108, 0.32)',
                  borderRadius: '4px',
                },
                maxHeight: 500,
              }}
            >
              <Table size="small" sx={{ minWidth: 500 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{ width: '30%', py: 1 }}>
                      <strong>Member</strong>
                    </TableCell>
                    {/* <TableCell align="center" sx={{ width: '40%', py: 1 }}>
                      <strong>Service</strong>
                    </TableCell> */}
                    <TableCell align="center" sx={{ width: '25%', py: 1 }}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight="bold">
                          Time
                        </Typography>
                        <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                          (HH:MM)
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                  (isAdminUser (userType) || userType === 8
                    ? subTaskMembers
                    : subTaskMembers.filter((item) => item.userId === userId)
                    ).length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No job members available
                      </TableCell>
                    </TableRow>
                    ) : 
                  (isAdminUser (userType) || userType === 8
                      ? subTaskMembers
                      : subTaskMembers.filter((item) => item.userId === userId)
                    ).map((item) => (
                    <TableRow key={item.id} sx={{mt:2, height: 44 }}>
                      <TableCell align="center">{item.name}</TableCell>

                      {/* {taskData?.service_id == null ? (
                        <TableCell>
                          <Autocomplete
                            fullWidth
                            size="small"
                            options={filteredClockInServices}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                              <TextField {...params} placeholder="Select service" size="small" />
                            )}
                            onChange={(event, newValue) => {
                              updateClockInInput(item.staff_id, {
                                service_id: newValue?.id || null,
                                hourly_rate: item.hourly_rate,
                                userId: item.userId,
                                timelog_id: item.timelog_id || item.log_id || null
                              });
                            }}
                          />
                        </TableCell>
                      ):
                        <TableCell>
                        <Autocomplete
                          fullWidth
                          size="small"
                          options={
                            filteredClockInServices.find((opt) => opt.id === taskData.customer_order_product_id)
                              ? filteredClockInServices.filter((opt) => opt.id === taskData.customer_order_product_id)
                              : filteredClockInServices
                          }
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select service" size="small" />
                          )}
                          onChange={(event, newValue) => {
                            updateClockInInput(item.staff_id, {
                              service_id: newValue?.id || null,
                              hourly_rate: item.hourly_rate,
                              userId: item.userId,
                              timelog_id: item.timelog_id || item.log_id || null
                            });
                          }}
                        />
                      </TableCell>
                      } */}

                      <TableCell>
                        {/* <TextField
                          // type="number"
                          label="Duration"
                          placeholder="e.g. 1:30 or 1.30.15"
                          size="small"
                          fullWidth
                          defaultValue={0}
                          onKeyDown={(e) => {
                          const allowedKeys = [
                            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                          ];

                          if (
                            !allowedKeys.includes(e.key) &&
                            !(e.key.length === 1 && allowedKeys.includes(e.key))
                          ) {
                            e.preventDefault();
                          }
                        }}
                          inputProps={{ min: 0, step: 0.1 }}
                          sx={{ '& input': { textAlign: 'center' } }}
                          // onChange={(e) => {
                          //   const hour = parseFloat(e.target.value);
                          //   updateClockInInput(item.staff_id, {
                          //     hour,
                          //     hourly_rate: item.hourly_rate,
                          //     userId: item.userId
                          //   });
                          // }}
                          onChange={(e) => {
                            const input = e.target.value.trim();
                            const parts = input.split(/[:.]/).map((p) => parseInt(p || 0, 10));

                            let [h = 0, m = 0, s = 0] = parts;

                            // Validate ranges
                            if (isNaN(h)) h = 0;
                            if (isNaN(m) || m > 59) m = 0;
                            if (isNaN(s) || s > 59) s = 0;

                            const decimal = h + m / 60 + s / 3600;
                            const selectedServiceId =
                              taskData?.service_id == null
                                // ? filteredClockInServices?.[0]?.id || null
                                 ? filteredClockInServices.find(s => s.labour_cost_service_id !== 10)?.id || null
                                : filteredClockInServices.find(opt => opt.id === taskData.customer_order_product_id)?.id || null;
                            updateClockInInput(item.staff_id, {
                              hour: decimal,
                              hourly_rate: item.hourly_rate,
                              userId: item.userId,
                              service_id: selectedServiceId,
                              timelog_id: item.timelog_id || item.log_id || null
                            });
                          }}
                        /> */}
                          <Stack direction="row" spacing={1} justifyContent="center">
                            <TextField
                              name="hours"  
                              label="Hours"
                              placeholder="01"
                              size="small"
                              sx={{ width: 80 }}
                              inputProps={{ min: 0 }}
                              // defaultValue={0}
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                                ];

                                if (
                                  !allowedKeys.includes(e.key) &&
                                  !(e.key.length === 1 && allowedKeys.includes(e.key))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const h = parseInt(e.target.value || '0', 10);
                                const m = parseInt(
                                  e.target.closest('tr').querySelector('input[name="minutes"]')?.value || '0',
                                  10
                                );

                                const totalMinutes = h * 60 + m;
                                const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                                const selectedServiceId =
                                taskData?.is_manually_added === 1 ? null :
                                  taskData?.service_id == null
                                    ? filteredClockInServices.find((s) => s.labour_cost_service_id !== 10)?.id || null
                                    : filteredClockInServices.find((opt) => opt.id === taskData.customer_order_product_id)?.id || null;

                                updateClockInInput(item.staff_id, {
                                  hour: decimal,
                                  // OLD: hourly_rate: item.hourly_rate,
                                  hourly_rate: resolveMemberLaborRate(item.hourly_rate),
                                  userId: item.userId,
                                  service_id: selectedServiceId,
                                  timelog_id: item.timelog_id || item.log_id || null
                                });
                              }}
                            />

                            <TextField
                              label="Minutes"
                              name="minutes"
                              placeholder="30"
                              size="small"
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                                ];

                                if (
                                  !allowedKeys.includes(e.key) &&
                                  !(e.key.length === 1 && allowedKeys.includes(e.key))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              sx={{ width: 80 }}
                              inputProps={{ min: 0, max: 60 }}
                              // defaultValue={0}
                              onInput={(e) => {
                                const value = parseInt(e.target.value || '0', 10);
                                if (value > 60) {
                                  e.target.value = 60;
                                } else if (value < 0) {
                                  e.target.value = 0;
                                }
                              }}
                              onChange={(e) => {
                                let m = parseInt(e.target.value || '0', 10);
                                let h = parseInt(
                                  e.target.closest('tr').querySelector('input[name="hours"]')?.value || '0',
                                  10
                                );

                                const totalMinutes = h * 60 + m;
                                const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                                const selectedServiceId =
                                  taskData?.service_id == null
                                    ? filteredClockInServices.find((s) => s.labour_cost_service_id !== 10)?.id || null
                                    : filteredClockInServices.find((opt) => opt.id === taskData.customer_order_product_id)?.id || null;

                                updateClockInInput(item.staff_id, {
                                  hour: decimal,
                                  // OLD: hourly_rate: item.hourly_rate,
                                  hourly_rate: resolveMemberLaborRate(item.hourly_rate),
                                  userId: item.userId,
                                  service_id: selectedServiceId,
                                  timelog_id: item.timelog_id || item.log_id || null
                                });
                              }}
                            />
                          </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>

              </Table>
            </DialogContent>

            <Stack direction="row" justifyContent="flex-end" spacing={2} px={3} mt={1} pb={2}>
              <Button
                onClick={() => {
                  setActiveSubtaskWorkflowRate(0)
                  handleClose();
                  enqueueSnackbar('Operation was cancelled', { variant: 'error' });
                }}
                sx={{
                  background: '#BB2525',
                  color: '#fff',
                  '&:hover': {
                    background: '#FF8F8F',
                  },
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  handleClockInOut()
                }
                }
                disabled={isClockInDisabled}
              >
                {loading2 ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Clock In'
                )}
              </Button>
            </Stack>
          </Dialog>
          {/* : ''
      } */}

      <Dialog
        open={openMembersPopup}
        onClose={() => setOpenMembersPopup(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Job Members ({popupMembers?.length || 0})
        </DialogTitle>
        <DialogContent>
          <Box sx={{ maxHeight: 350, overflowY: 'auto', mt: 1 }}>
            <Stack spacing={2}>
              {popupMembers?.map((row) => (
                <Stack key={row.id} direction="row" spacing={2} alignItems="center">
                  <Avatar src={row.profile_pic} alt={row.name} />
                  <Typography variant="body1">{row.name || 'No Name'}</Typography>
                </Stack>
              ))}
            </Stack>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setOpenMembersPopup(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div style={{ display: 'none' }}>
        {/* <div ref={detailsRef} style={{ ...labelStyle1, margin: '0' }}> */}
        <div ref={detailsRef} 
         style={{
          position: 'absolute',
          top: `${smallLabelSettings.marginTop}px`,
          left: `${smallLabelSettings.marginLeft}px`,
          transform: `scale(${smallLabelSettings.scale})`,
          transformOrigin: 'top left',
          paddingTop: `${smallLabelSettings.paddingTop}px`,
          paddingRight: `${smallLabelSettings.paddingRight}px`,
          paddingBottom: `${smallLabelSettings.paddingBottom}px`,
          paddingLeft: `${smallLabelSettings.paddingLeft}px`,
          width: `${smallLabelSettings.width}in`,
          height: smallLabelSettings.height,
          fontFamily: 'Arial, sans-serif',
          fontSize: '8px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
          >
          <div>
            <div style={rowStyle1}>
              {!empty(partialProductNew?.barcode) && (
                <>
                  <div style={qrCodeSection}>
                    <QRCode
                      value={partialProductNew?.barcode}
                      size={smallLabelSettings.qrSize}
                      bgColor={'#ffffff'}
                      fgColor={'#000000'}       
                      includeMargin={false}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <Typography variant="caption" style={{
            ...typographyStyle1,
            fontSize: `${smallLabelSettings.smallTitleFontSize}px`,
            fontWeight: 'bold',
            marginBottom: '2px'
          }}
          >PARTIAL</Typography>
          
          {/* New code - shows full name without CSS truncation, but truncates after 100 characters */}
          <Typography variant="caption" style={{
            ...typographyStyle1,
            fontSize: `${smallLabelSettings.smallTitleFontSize}px`,
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            overflow: 'visible',
          }}>
            {partialTargetProduct?.name && partialTargetProduct?.name.length > 100 
              ? `${partialTargetProduct?.name.substring(0, 100)}...` 
              : partialTargetProduct?.name || partialTargetProduct?.product_name}
          </Typography>
        </div>
      </div>

    </Grid>
  )
}
